/* Bearings Calculator UI (no filtering logic)
 * - Handles view navigation (Search, Evaluate, Fits)
 * - Handles Select Calculations modal open/close and Select All
 * - Leaves filtering to shared filter.js (action=find_parts)
 */
(function(window, document){
  'use strict';

    // Option A: Initialize grease catalog in the main bundle so selections work on first render
    (function initGreaseCatalog(){
      try {
        if (!Array.isArray(window.BC_GREASES) || !window.BC_GREASES.length) {
          window.BC_GREASES = [
            {code:'LY121', name:'Lithium Soap Grease', grease_type:'Lithium Soap Grease', thickener:'Lithium Soap', base_oil:['Ester'], visc40_cst:24, penetration_25C_60W:250, temp_min_C:-50, temp_max_C:150, ratings:{noise:8, torque:6, high_temp:4, low_temp:4, high_speed:3, plastic_compat:2, cost:8}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY72', name:'Lithium Soap Grease — Low Torque', grease_type:'Lithium Soap Grease', thickener:'Lithium Soap', base_oil:['Ester'], visc40_cst:16, penetration_25C_60W:275, temp_min_C:-50, temp_max_C:130, ratings:{noise:8, torque:8, high_temp:3, low_temp:6, high_speed:3, plastic_compat:2, cost:6}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY551', name:'Urea Grease — Heat Resistance High Speed', grease_type:'Urea Grease', thickener:'Urea', base_oil:['Synthetic Hydrocarbon'], visc40_cst:48, penetration_25C_60W:235, temp_min_C:-40, temp_max_C:200, ratings:{noise:6, torque:4, high_temp:6, low_temp:3, high_speed:6, plastic_compat:4, cost:8}, conductive:false, plastic_compat_flag:'ok'},
            {code:'LY706', name:'Ester Oil Grease — Urea Thickener', grease_type:'Urea Grease', thickener:'Urea', base_oil:['Ester'], visc40_cst:100, penetration_25C_60W:263, temp_min_C:-40, temp_max_C:180, ratings:{noise:3, torque:3, high_temp:7, low_temp:2, high_speed:6, plastic_compat:2, cost:3}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY500', name:'Fluorinated Grease — Heat Resistance', grease_type:'Fluorinated Grease', thickener:'PTFE', base_oil:['Fluorinated'], visc40_cst:190, penetration_25C_60W:280, temp_min_C:-50, temp_max_C:260, ratings:{noise:null, torque:3, high_temp:9, low_temp:null, high_speed:null, plastic_compat:null, cost:2}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY586', name:'Fluorinated Grease — Heat Resistance', grease_type:'Fluorinated Grease', thickener:'PTFE', base_oil:['Fluorinated'], visc40_cst:85, penetration_25C_60W:280, temp_min_C:-65, temp_max_C:220, ratings:{noise:null, torque:4, high_temp:8, low_temp:4, high_speed:3, plastic_compat:null, cost:2}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY699', name:'Fluorinated Grease — Heat Resistance Low Torque', grease_type:'Fluorinated Grease', thickener:'PTFE', base_oil:['Fluorinated'], visc40_cst:85, penetration_25C_60W:280, temp_min_C:-50, temp_max_C:220, ratings:{noise:null, torque:5, high_temp:8, low_temp:6, high_speed:3, plastic_compat:null, cost:1}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY655', name:'Fluorinated Grease — Cost Effective', grease_type:'Fluorinated Grease', thickener:'PTFE', base_oil:['Fluorinated','Ester'], visc40_cst:210, penetration_25C_60W:290, temp_min_C:-40, temp_max_C:200, ratings:{noise:2, torque:3, high_temp:9, low_temp:null, high_speed:null, plastic_compat:2, cost:3}, conductive:false, plastic_compat_flag:'contact'},
            {code:'LY764', name:'Conductive Grease', grease_type:'Conductive Grease', thickener:'Carbon', base_oil:['Synthetic Hydrocarbon'], visc40_cst:120, penetration_25C_60W:260, temp_min_C:-40, temp_max_C:120, ratings:{noise:2, torque:null, high_temp:6, low_temp:null, high_speed:2, plastic_compat:4, cost:3}, conductive:true, plastic_compat_flag:'ok'},
            {code:'LY768', name:'Conductive Grease — Heat Resistant', grease_type:'Conductive Grease', thickener:'Carbon', base_oil:['Fluorinated'], visc40_cst:390, penetration_25C_60W:260, temp_min_C:-30, temp_max_C:260, ratings:{noise:2, torque:null, high_temp:8, low_temp:null, high_speed:2, plastic_compat:4, cost:2}, conductive:true, plastic_compat_flag:'ok'},
            {code:'LO1', name:'Oil — Low Torque', grease_type:'Oil', thickener:'-', base_oil:['Ester'], visc40_cst:12, penetration_25C_60W:null, temp_min_C:-57, temp_max_C:177, ratings:{noise:6, torque:9, high_temp:3, low_temp:6, high_speed:3, plastic_compat:2, cost:4}, conductive:false, plastic_compat_flag:'ok', catalog_only:true},
            {code:'LY650', name:'Oil — Plastic Compatibility', grease_type:'Oil', thickener:'-', base_oil:['Synthetic Hydrocarbon'], visc40_cst:32, penetration_25C_60W:null, temp_min_C:-40, temp_max_C:130, ratings:{noise:6, torque:9, high_temp:3, low_temp:4, high_speed:3, plastic_compat:4, cost:3}, conductive:false, plastic_compat_flag:'ok', catalog_only:true}
          ];
        }
      } catch(e) { /* no-op */ }
    })();

    // Shared helpers for lubrication selection across panels/cards
    function bc_buildGreaseWeights(ndm, T){
      var w = { temp:7, viscosity:5, noise:3, torque:2, cost:1, conductivity:1 };
      var Tn = (typeof T === 'string') ? parseFloat(T) : T;
      if (Number.isFinite(Tn)){
        if (Tn < -30) w.temp += 1;
        if (Tn > 120) w.temp += 1;
      }
      if (Number.isFinite(ndm)){
        if (ndm > 1000000) w.viscosity += 1;
        if (ndm > 500000)  w.noise += 1;
      }
      return w;
    }
    function bc_scoreGrease(g, w, ndm, T, prefs){
      var s = 0;
      var Tn = (typeof T === 'string') ? parseFloat(T) : T;
      prefs = prefs || {};
      if (Number.isFinite(Tn)) {
        if (Tn < g.temp_min_C) s -= 5;
        if (Tn > g.temp_max_C) s -= 5;
      }
      s += (w && w.temp ? w.temp : 0) * 1.0;

      if (prefs.noise) s += (g.ratings && typeof g.ratings.noise === 'number') ? g.ratings.noise : 5;
      if (prefs.cost)  s += (g.ratings && typeof g.ratings.cost  === 'number') ? g.ratings.cost  : 5;

      // High temperature (above 180°C): rule-based overrides
      var highTemp = Number.isFinite(Tn) && Tn > 180;
      if (highTemp) {
        if (g.code === 'LY500') s += 20.0;
        if (prefs.torque && g.code === 'LY699') s += 25.0;
        if (prefs.cost   && g.code === 'LY655') s += 25.0;
        return s;
      }

      // Low torque preference
      if (prefs.torque) {
        if (prefs.cost && g.code === 'LY121') s += 25.0;
        else if (Number.isFinite(ndm) && ndm > 50000 && g.code === 'LY551') s += 25.0;
        else if (g.code === 'LY72') s += 20.0;
        else s += (g.ratings && typeof g.ratings.torque === 'number') ? g.ratings.torque : 5;
      }

      if (Number.isFinite(ndm)) {
        if (ndm > 1000000 && g.visc40_cst > 120) s -= 1.5;
        if (ndm > 500000 && g.visc40_cst > 190) s -= 1.0;
        if (ndm < 200000 && g.visc40_cst < 16)  s -= 0.5;
        // Explicit ndm-based baseline switch: below threshold favor LY121; above favor LY551
        var NDM_SWITCH = 50000;
        if (ndm >= NDM_SWITCH) {
          if (g.code === 'LY551') s += 4.0;
          if (g.code === 'LY121') s -= 1.5;
        } else {
          if (g.code === 'LY121') s += 1.0;
        }
      }
      // Baseline guidance by temperature: 120–180°C → LY551
      if (Number.isFinite(Tn)) {
        if (Tn >= 120 && Tn <= 180 && g.code === 'LY551') s += 5.0;
      }
      return s;
    }
    function bc_selectGrease(params){
      var arr = (window.BC_GREASES || []).slice();
      // No operating temperature given → assume ambient 25 °C. Callers coerce this too,
      // but the default belongs here so the engine can't disagree with a caller that forgets.
      var Tn = parseFloat(params ? params.T : undefined);
      if (!Number.isFinite(Tn)) Tn = 25;
      arr = arr.filter(function(g){
        if (g.catalog_only) return false;
        if (Number.isFinite(Tn)) {
          if (!(Tn >= g.temp_min_C && Tn <= g.temp_max_C)) return false;
        }
        if (params.requireCond && !g.conductive) return false;
        if (params.plasticPresent) {
          if (g.plastic_compat_flag === 'contact') return false;
        }
        return true;
      });
      var w = bc_buildGreaseWeights(params.ndm, Tn);
      var prefs = { noise: !!params.noise, torque: !!params.torque, cost: !!params.cost };
      var scored = arr.map(function(g){ return { g:g, score: bc_scoreGrease(g, w, params.ndm, Tn, prefs) }; });
      scored.sort(function(a,b){ return b.score - a.score; });
      return { weights:w, scored:scored };
    }
    // Single source of truth for grease selection on this page (mirrors
    // BearingCalculatorService.selectGrease). The Evaluate cards and the Grease
    // Recommendation modal must both go through this — never a local copy.
    window.bcSelectGrease = bc_selectGrease;

  // ── Client-side calculation engine (mirrors BearingCalculatorService.js) ──────

  var BC_TOLERANCES = {
    shaft: { bands: [
      {over:0,  up_to_incl:3,  classes:{h5:[0,-4],  h6:[0,-6],  f6:[-6,-12],  g5:[-2,-6],  g6:[-2,-8],  k5:[+4,0],  k6:[+6,0],  m5:[+6,+2],  m6:[+8,+2],  n6:[+10,+4],  p6:[+12,+6],  r6:[+16,+10],  js5:[-2,+2],   js6:[-3,+3]}},
      {over:3,  up_to_incl:6,  classes:{h5:[0,-5],  h6:[0,-8],  f6:[-10,-18], g5:[-4,-9],  g6:[-4,-12], k5:[+6,+1], k6:[+9,+1], m5:[+9,+4],  m6:[+12,+4], n6:[+16,+8],  p6:[+20,+12], r6:[+23,+15], js5:[-2.5,+2.5],js6:[-4,+4]}},
      {over:6,  up_to_incl:10, classes:{h5:[0,-6],  h6:[0,-9],  f6:[-13,-22], g5:[-5,-11], g6:[-5,-14], k5:[+7,+1], k6:[+10,+1],m5:[+12,+6], m6:[+15,+6], n6:[+19,+10], p6:[+24,+15], r6:[+28,+19], js5:[-3,+3],    js6:[-4.5,+4.5]}},
      {over:10, up_to_incl:18, classes:{h5:[0,-8],  h6:[0,-11], f6:[-16,-27], g5:[-6,-14], g6:[-6,-17], k5:[+9,+1], k6:[+12,+1],m5:[+15,+7], m6:[+18,+7], n6:[+23,+12], p6:[+29,+18], r6:[+34,+23], js5:[-4,+4],    js6:[-5.5,+5.5]}},
      {over:18, up_to_incl:30, classes:{h5:[0,-9],  h6:[0,-13], f6:[-20,-33], g5:[-7,-16], g6:[-7,-20], k5:[+11,+2],k6:[+15,+2],m5:[+17,+8], m6:[+21,+8], n6:[+28,+15], p6:[+35,+22], r6:[+41,+28], js5:[-4.5,+4.5],js6:[-6.5,+6.5]}}
    ]},
    hole: { bands: [
      {over:0,  up_to_incl:3,  classes:{H6:[0,+6],  H7:[0,+10], G6:[+2,+8],  G7:[+2,+12], JS6:[-3,+3],  JS7:[-5,+5],  K6:[0,-6],   K7:[0,-10],  M6:[-2,-8],  M7:[-2,-12], N6:[-4,-10], N7:[-4,-14], P7:[-6,-16]}},
      {over:3,  up_to_incl:6,  classes:{H6:[0,+8],  H7:[0,+12], G6:[+4,+12], G7:[+4,+16], JS6:[-4,+4],  JS7:[-6,+6],  K6:[+2,-6],  K7:[+3,-9],  M6:[-1,-9],  M7:[0,-12],  N6:[-5,-13], N7:[-4,-16], P7:[-8,-20]}},
      {over:6,  up_to_incl:10, classes:{H6:[0,+9],  H7:[0,+15], G6:[+5,+14], G7:[+5,+20], JS6:[-4.5,+4.5],JS7:[-7.5,+7.5],K6:[+2,-7],K7:[+5,-10],M6:[-3,-12], M7:[0,-15],  N6:[-7,-16], N7:[-4,-19], P7:[-9,-24]}},
      {over:10, up_to_incl:18, classes:{H6:[0,+11], H7:[0,+18], G6:[+6,+17], G7:[+6,+24], JS6:[-5.5,+5.5],JS7:[-9,+9],  K6:[+2,-9],  K7:[+6,-12], M6:[-4,-15], M7:[0,-18],  N6:[-9,-20], N7:[-5,-23], P7:[-11,-29]}},
      {over:18, up_to_incl:30, classes:{H6:[0,+13], H7:[0,+21], G6:[+7,+20], G7:[+7,+28], JS6:[-6.5,+6.5],JS7:[-10.5,+10.5],K6:[+2,-11],K7:[+6,-15],M6:[-4,-17],M7:[0,-21],  N6:[-11,-24],N7:[-7,-28], P7:[-14,-35]}}
    ]},
    map: {
      inner_ring: {
        ABEC1: ['r6','p6','n6','m6','k6','k5','js6','h6','h5','g6','f6'],
        ABEC3: ['r6','p6','n6','m6','k5','js6','h5','h5','g5','f6'],
        ABEC5: ['m5','k4','js4','h4','h5']
      },
      outer_ring: {
        ABEC1: ['P7','N7','N6','M7','K7','JS7','H7','G7'],
        ABEC3: ['P7','N6','M6','K6','JS6','H6','G7'],
        ABEC5: ['M5','K5','JS5','H5']
      },
      presets: {
        inner_rotates: {shaft:'k6', hole:'H7'},
        outer_rotates: {shaft:'f6', hole:'N6'},
        indeterminate:  {shaft:'f6', hole:'N6'}
      }
    }
  };

  function bc_lookupEXY(Fa, Fr, Dw_mm, Z){
    var r = (Z * Dw_mm * Dw_mm) > 0 ? (Fa / (Z * Dw_mm * Dw_mm)) : Infinity;
    var table = [
      [0.172,0.19,2.30],[0.345,0.22,1.99],[0.689,0.26,1.71],
      [1.030,0.28,1.55],[1.380,0.30,1.45],[2.070,0.34,1.31],
      [3.450,0.38,1.15],[5.170,0.42,1.04],[6.890,0.44,1.00]
    ];
    function build(e, Yhi){
      var ratio = (Fr > 0) ? (Fa / Fr) : Infinity;
      if (ratio <= e) return {e:e, X:1.0, Y:0.0, branch:'Fa/Fr <= e'};
      return {e:e, X:0.56, Y:Yhi, branch:'Fa/Fr > e'};
    }
    if (r <= table[0][0]) return build(table[0][1], table[0][2]);
    var n = table.length;
    for (var i = 0; i < n - 1; i++) {
      if (r > table[i][0] && r <= table[i+1][0]) {
        var t = (table[i+1][0] - table[i][0]) > 0 ? ((r - table[i][0]) / (table[i+1][0] - table[i][0])) : 0;
        return build(table[i][1] + t*(table[i+1][1]-table[i][1]), table[i][2] + t*(table[i+1][2]-table[i][2]));
      }
    }
    return build(table[n-1][1], table[n-1][2]);
  }

  function bc_calculateDEL(specs, params){
    if (!specs) return {success:false, error:'Bearing specs not found'};
    var Fr = parseFloat(params.radial_load || 0);
    var Fa = parseFloat(params.axial_load  || 0);
    if (Fr <= 0 && Fa <= 0) return {success:false, error:'Loads must be > 0'};
    var Dw = parseFloat(specs['ball-size-dw-mm'] || specs.ball_size_dw_mm || specs.Dw || 0);
    var Z  = parseFloat(specs['ball-complement-z'] || specs.ball_complement_z || specs.Z || 0);
    if (Dw > 0 && Z > 0) {
      var exy = bc_lookupEXY(Fa, Fr, Dw, Z);
      var P = (exy.branch === 'Fa/Fr <= e') ? Fr : (exy.X * Fr + exy.Y * Fa);
      var formula = (exy.branch === 'Fa/Fr <= e') ? 'P = Fr (Fa/Fr <= e)' : 'P = 0.56·Fr + Y·Fa (Fa/Fr > e)';
      return {success:true, dynamic_equivalent_load:P, X_factor:exy.X, Y_factor:exy.Y, e_factor:exy.e, load_ratio:(Fr>0?Fa/Fr:null), formula:formula};
    }
    return {success:false, error:'Ball size (Dw) and ball complement (Z) must be mapped for this part.'};
  }

  function bc_calculateFits(specs, params){
    var d = params.shaft_d_mm   ? parseFloat(params.shaft_d_mm)   : parseFloat((specs && (specs['bore-diameter-mm']    || specs.bore_d_mm    || specs.d)) || 0);
    var D = params.housing_D_mm ? parseFloat(params.housing_D_mm) : parseFloat((specs && (specs['outside-diameter-mm'] || specs.outer_diameter_mm || specs.D)) || 0);
    if (d <= 0 || D <= 0) return {success:false, error:'Nominal shaft (d='+d+') and housing (D='+D+') diameters are required'};

    var abecIn = ((params.abec || 'ABEC1')+'').toUpperCase();
    var abec = (['ABEC1','ABEC3','ABEC5'].indexOf(abecIn) >= 0) ? abecIn : 'ABEC1';
    var rotIn = ((params.rotation || 'inner_rotates')+'').toLowerCase();
    var rotation = (['inner_rotates','outer_rotates','indeterminate'].indexOf(rotIn) >= 0) ? rotIn : 'inner_rotates';

    function findBand(bands, val){
      for (var i=0;i<bands.length;i++){
        var b=bands[i], over=parseFloat(b.over), upto=parseFloat(b.up_to_incl);
        if (val > over && val <= upto) return b;
        if (val <= 0 && over === 0 && val <= upto) return b;
      }
      return null;
    }
    var shaftBand = findBand(BC_TOLERANCES.shaft.bands, d);
    var holeBand  = findBand(BC_TOLERANCES.hole.bands,  D);
    if (!shaftBand || !holeBand) return {success:false, error:'Size out of supported tolerance bands'};

    var preset = BC_TOLERANCES.map.presets[rotation] || {shaft:'k6', hole:'H7'};
    var shaftClass = ((params.shaft_class || preset.shaft)+'').toLowerCase();
    var holeClass  = ((params.hole_class  || preset.hole )+'').toUpperCase();

    var shaftTol = shaftBand.classes[shaftClass] || null;
    var holeTol  = holeBand.classes[holeClass]   || null;
    if (!shaftTol || !holeTol) return {success:false, error:'Selected classes not available for the chosen size band'};

    var s_low = parseFloat(shaftTol[0]), s_high = parseFloat(shaftTol[1]);
    var h_low = parseFloat(holeTol[0]),  h_high = parseFloat(holeTol[1]);

    var alpha_defaults = {steel:11.5e-6, aluminum:23e-6, cast_iron:10.5e-6};
    var mat_shaft   = ((params.shaft_material   || 'steel')+'').toLowerCase();
    var mat_housing = ((params.housing_material || 'steel')+'').toLowerCase();
    var alpha_shaft   = params.alpha_shaft   !== undefined ? parseFloat(params.alpha_shaft)   : (alpha_defaults[mat_shaft]   || 11.5e-6);
    var alpha_housing = params.alpha_housing !== undefined ? parseFloat(params.alpha_housing) : (alpha_defaults[mat_housing] || 11.5e-6);
    var T0        = params.T0        !== undefined ? parseFloat(params.T0)        : 20.0;
    var T_shaft   = params.T_shaft   !== undefined ? parseFloat(params.T_shaft)   : T0;
    var T_housing = params.T_housing !== undefined ? parseFloat(params.T_housing) : T0;

    var dth_um = alpha_shaft   * d * (T_shaft   - T0) * 1000.0;
    var Dth_um = alpha_housing * D * (T_housing - T0) * 1000.0;

    var s_low_eff  = s_low  + dth_um;  var s_high_eff = s_high + dth_um;
    var h_low_eff  = h_low  - Dth_um;  var h_high_eff = h_high - Dth_um;

    var C_min = h_low_eff  - s_high_eff;
    var C_max = h_high_eff - s_low_eff;
    var fit_class = (C_min > 0) ? 'Clearance' : ((C_max < 0) ? 'Interference' : 'Intermediate');

    var warnings = [];
    var rec_shaft_list = BC_TOLERANCES.map.inner_ring[abec] || [];
    var rec_hole_list  = BC_TOLERANCES.map.outer_ring[abec] || [];
    if (rotation === 'inner_rotates') {
      if (rec_shaft_list.map(function(s){return s.toLowerCase();}).indexOf(shaftClass.toLowerCase()) < 0)
        warnings.push('Selected shaft class not typical for rotating inner ring at '+abec+' per mapping.');
    } else {
      if (rec_hole_list.map(function(s){return s.toUpperCase();}).indexOf(holeClass.toUpperCase()) < 0)
        warnings.push('Selected hole class not typical for rotating/indeterminate outer ring at '+abec+' per mapping.');
    }

    return {
      success:true,
      inputs:{abec:abec, rotation:rotation, d_mm:d, D_mm:D, shaft_class:shaftClass, hole_class:holeClass,
              materials:{shaft:mat_shaft, housing:mat_housing},
              alphas_per_K:{shaft:alpha_shaft, housing:alpha_housing},
              temperatures_C:{T0:T0, T_shaft:T_shaft, T_housing:T_housing}},
      bands:{shaft:{over:shaftBand.over, up_to_incl:shaftBand.up_to_incl}, hole:{over:holeBand.over, up_to_incl:holeBand.up_to_incl}},
      deviations_um:{shaft:{low:s_low, high:s_high}, hole:{low:h_low, high:h_high}},
      thermal_um:{shaft_growth:dth_um, housing_bore_growth:Dth_um},
      effective_limits_um:{shaft:{low:s_low_eff, high:s_high_eff}, hole:{low:h_low_eff, high:h_high_eff}},
      clearance_um:{min:C_min, max:C_max},
      clearance_mm:{min:C_min/1000.0, max:C_max/1000.0},
      fit_classification:fit_class,
      warnings:warnings
    };
  }

  // ── End client-side calculation engine ────────────────────────────────────────

  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function byId(id){ return document.getElementById(id); }

  var currentBcTab = 'search';
  var updateStickyBar = null; // set by initSelection; called by setActiveNav on tab change

  function setActiveNav(target){
    try { if (window.Sentry && window.Sentry.addBreadcrumb) { window.Sentry.addBreadcrumb({ category:'bc.ui', message:'nav:'+target, level:'info' }); }} catch(e){}
    var panels = {
      search: byId('search-panel'),
      evaluate: byId('evaluate-panel'),
      fits: byId('fits-panel')
    };
    Object.keys(panels).forEach(function(k){ if (panels[k]) panels[k].style.display = (k === target ? 'block' : 'none'); });
    currentBcTab = target;
    // Hide the sticky bar when user navigates away from the search tab
    if (updateStickyBar) { try { updateStickyBar(); } catch(e){} }
    // visuals
    var wide = window.innerWidth > 720;
    $all('.js-calc-nav-btn').forEach(function(btn){
      var isActive = btn.getAttribute('data-target') === target;
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.style.background = isActive ? '#0d5cab' : '#e9edf2';
      btn.style.color = isActive ? '#fff' : '#9aa6b2';
      btn.style.borderColor = isActive ? '#0d5cab' : '#d7dee7';
      if (wide) {
        btn.style.flex = isActive ? '1 1 0%' : '0 1 auto';
      } else {
        btn.style.flex = '';
      }
    });
  }

  function hideModal(){ var m = byId('calc-modal'); if (m){ m.style.display='none'; m.setAttribute('aria-hidden','true'); }}

  function initModal(){
    $all('.js-calc-modal-close').forEach(function(btn){ btn.addEventListener('click', hideModal); });
    var selectAll = byId('calc-select-all');
    if (selectAll){
      selectAll.addEventListener('change', function(){
        $all('#calc-modal-form input[type="checkbox"][name="calc[]"]').forEach(function(cb){ cb.checked = selectAll.checked; });
      });
    }
    var cont = byId('calc-modal-continue');
    if (cont){ cont.addEventListener('click', hideModal); }
  }

  function selectionIsEmpty(){
    // Prefer the selection structure used by the page if exposed
    if (window.BC_SELECTED && typeof window.BC_SELECTED.size === 'number') { return window.BC_SELECTED.size === 0; }
    // Fallback: look for any checked result checkboxes in results table
    var any = document.querySelector('#search-results input[type="checkbox"]:checked');
    return !any;
  }

  function initNav(){
    $all('.js-calc-nav-btn').forEach(function(btn){
      if (btn._bcBound) return; btn._bcBound = true;
      btn.addEventListener('click', function(){
        var target = btn.getAttribute('data-target');
        if ((target === 'evaluate' || target === 'fits') && selectionIsEmpty()) {
          // Nudge the user to select first, but do not block navigation
          try { var results = byId('search-panel'); if (results && results.scrollIntoView) results.scrollIntoView({behavior:'smooth'}); } catch(e){}
        }
        setActiveNav(target);
        try { if (target === 'evaluate' && typeof window.updateResultsSummary === 'function') { window.updateResultsSummary(); } } catch(e){}
        try { if (target === 'fits' && typeof window.bcInitFitsPanel === 'function') { window.bcInitFitsPanel(); } } catch(e){}
        try { if (target === 'evaluate') { setTimeout(function(){ if (typeof window.bcScrollToEvaluateOC === 'function') { window.bcScrollToEvaluateOC(); } else { var el = document.getElementById('operating-conditions'); if (el) { var y = (el.getBoundingClientRect().top + (window.pageYOffset||document.documentElement.scrollTop||0)) - 142; window.scrollTo({top:y, behavior:'smooth'}); } } }, 60); } } catch(e){}
      });
      btn.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }});
    });
    setActiveNav('search');
  }

  function initSelection(){
    window.bcSelectedParts = window.bcSelectedParts || new Set();
    var selectPageBtn = byId('btn-select-page');
    var clearBtn = byId('btn-clear-selection');
    var evaluateNowBtn = byId('btn-evaluate-now');
    var counter = byId('selection-counter');
    var chipsContainer = byId('selection-chips');

    function updateCounter(){
      if (counter) {
        var count = window.bcSelectedParts.size;
        counter.textContent = count + '/5 selected';
        counter.style.color = count > 5 ? '#d93025' : '#0057B8';
      }
    }

    function renderChips(){
      if (!chipsContainer) return;
      chipsContainer.innerHTML = '';
      window.bcSelectedParts.forEach(function(pn){
        var chip = document.createElement('div');
        chip.className = 'chip';
        chip.setAttribute('data-pn', pn);
        chip.style.cssText = 'display:inline-flex; align-items:center; gap:6px; background:#eef5ff; color:#0d5cab; padding:4px 10px; border-radius:999px; font-size:13px; font-weight:600; border:1px solid #cce3ff;';
        
        var label = (window.BC_PARTS && window.BC_PARTS[pn] && window.BC_PARTS[pn].title) ? window.BC_PARTS[pn].title : pn;
        var span = document.createElement('span');
        span.textContent = label;
        chip.appendChild(span);

        var close = document.createElement('span');
        close.textContent = '×';
        close.style.cssText = 'cursor:pointer; font-size:16px; line-height:1; margin-left:2px;';
        close.addEventListener('click', function(){
          window.bcSelectedParts.delete(pn);
          syncCheckboxes();
          renderChips();
          updateCounter();
          triggerSelectionChange();
        });
        chip.appendChild(close);
        chipsContainer.appendChild(chip);
      });
    }

    function syncCheckboxes(){
      $all('.js-bc-select').forEach(function(cb){
        cb.checked = window.bcSelectedParts.has(cb.value);
      });
    }

    function triggerSelectionChange(){
      document.dispatchEvent(new CustomEvent('bc-selection-changed', { detail: { selected: Array.from(window.bcSelectedParts) } }));
    }

    document.addEventListener('change', function(e){
      if (e.target && e.target.classList && e.target.classList.contains('js-bc-select')) {
        var pn = e.target.value;
        if (e.target.checked) {
          if (window.bcSelectedParts.size >= 5) {
            e.target.checked = false;
            alert('Maximum 5 bearings can be selected for evaluation.');
            return;
          }
          window.bcSelectedParts.add(pn);
        } else {
          window.bcSelectedParts.delete(pn);
        }
        renderChips();
        updateCounter();
        triggerSelectionChange();
      }
    });

    if (selectPageBtn) {
      selectPageBtn.addEventListener('click', function(){
        var added = 0;
        $all('.js-bc-select').forEach(function(cb){
          if (!cb.checked && window.bcSelectedParts.size < 5) {
            cb.checked = true;
            window.bcSelectedParts.add(cb.value);
            added++;
          }
        });
        if (added > 0) {
          renderChips();
          updateCounter();
          triggerSelectionChange();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function(){
        window.bcSelectedParts.clear();
        syncCheckboxes();
        renderChips();
        updateCounter();
        triggerSelectionChange();
      });
    }

    if (evaluateNowBtn) {
      evaluateNowBtn.addEventListener('click', function(){
        if (window.bcSelectedParts.size === 0) {
          alert('Please select at least one bearing to evaluate.');
          return;
        }
        setActiveNav('evaluate');
        if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary();
      });
    }

    // Sticky bottom bar
    var stickyBar = byId('bc-sticky-bar');
    var stickyCounter = byId('bc-sticky-bar-counter');
    var stickyEvaluateBtn = byId('btn-sticky-evaluate-now');

    updateStickyBar = function updateStickyBar(){
      if (!stickyBar) return;
      var count = window.bcSelectedParts ? window.bcSelectedParts.size : 0;
      if (count > 0 && currentBcTab === 'search') {
        if (stickyCounter) stickyCounter.textContent = count + (count === 1 ? ' bearing' : ' bearings') + ' selected — ready to evaluate';
        stickyBar.style.display = 'block';
      } else {
        stickyBar.style.display = 'none';
      }
    }

    if (stickyEvaluateBtn) {
      stickyEvaluateBtn.addEventListener('click', function(){
        setActiveNav('evaluate');
        if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    document.addEventListener('bc-selection-changed', updateStickyBar);

    // Handle AJAX content updates
    var resultsTable = document.querySelector('.js-filter-content-rows');
    if (resultsTable) {
      var obs = new MutationObserver(function(){
        syncCheckboxes();
        // Try to fetch titles for newly added PNs if they are IDs
        var ids = [];
        window.bcSelectedParts.forEach(function(v){ if (ctype_digit(v)) ids.push(parseInt(v,10)); });
        if (ids.length && window.BC_PARTS) {
           // We might want to fetch titles here if not already in BC_PARTS
        }
      });
      obs.observe(resultsTable, { childList: true });
    }

    function ctype_digit(str) {
      return /^\d+$/.test(str);
    }
  }

  function initLoadCases(){
    var btn = byId('add-load-case');
    var wrap = byId('load-cases-container');
    if (!btn || !wrap) return;
    function renderRow(idx){
      var row = document.createElement('div');
      row.className = 'oc-row';
      row.innerHTML = ''
        + '<div class="oc-label"><span>Load Case '+idx+'</span></div>'
        + '<div class="oc-inputs">'
        + ' <div class="oc-input">'
        + '  <input type="number" step="any" placeholder="" class="lc-input" data-field="radial_load" style="width:100%; padding:.6rem .9rem; padding-right:48px; border:1px solid #dfe3e8; border-radius:8px;" />'
        + '  <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); background:#f3f4f6; border:1px solid #e5e7eb; color:#6b7280; border-radius:6px; padding:.25rem .4rem; font-size:12px;">N</span>'
        + ' </div>'
        + ' <div class="oc-input">'
        + '  <input type="number" step="any" placeholder="" class="lc-input" data-field="axial_load" style="width:100%; padding:.6rem .9rem; padding-right:48px; border:1px solid #dfe3e8; border-radius:8px;" />'
        + '  <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); background:#f3f4f6; border:1px solid #e5e7eb; color:#6b7280; border-radius:6px; padding:.25rem .4rem; font-size:12px;">N</span>'
        + ' </div>'
        + ' <div class="oc-input">'
        + '  <input type="number" step="1" placeholder="" class="lc-input" data-field="speed" style="width:100%; padding:.6rem .9rem; padding-right:48px; border:1px solid #dfe3e8; border-radius:8px;" />'
        + '  <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); background:#f3f4f6; border:1px solid #e5e7eb; color:#6b7280; border-radius:6px; padding:.25rem .4rem; font-size:12px;">r/min</span>'
        + ' </div>'
        + ' <div class="oc-input">'
        + '  <input type="number" step="any" placeholder="" class="lc-input" data-field="temperature" style="width:100%; padding:.6rem .9rem; padding-right:48px; border:1px solid #dfe3e8; border-radius:8px;" />'
        + '  <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); background:#f3f4f6; border:1px solid #e5e7eb; color:#6b7280; border-radius:6px; padding:.25rem .4rem; font-size:12px;">°C</span>'
        + ' </div>'
        + ' <div class="oc-input">'
        + '  <input type="number" step="1" min="0" max="100" placeholder="" class="lc-input" data-field="duty_cycle" style="width:100%; padding:.6rem .9rem; padding-right:48px; border:1px solid #dfe3e8; border-radius:8px;" />'
        + '  <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); background:#f3f4f6; border:1px solid #e5e7eb; color:#6b7280; border-radius:6px; padding:.25rem .4rem; font-size:12px;">%</span>'
        + ' </div>'
        + '</div>'
        + '<div class="oc-del-wrap">'
        + '  <button type="button" class="oc-del" title="Remove load case" aria-label="Remove Load Case" style="border:none; background:none; cursor:pointer; color:#9aa6b2; display:inline-flex; align-items:center; justify-content:center; width:32px; height:32px; border-radius:4px; transition:color .15s, background .15s;" onmouseenter="this.style.color=\'#c0392b\';this.style.background=\'#fef2f2\';" onmouseleave="this.style.color=\'#9aa6b2\';this.style.background=\'none\';">'
        + '    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>'
        + '  </button>'
        + '</div>';
      var del = row.querySelector('.oc-del');
      if (del) del.addEventListener('click', function(){ row.remove(); renumber(); try { if (typeof toggleResultsVisibility === 'function') toggleResultsVisibility(); } catch(e){} });
      return row;
    }
    function renumber(){
      var rows = wrap.children;
      var count = rows.length;
      var equalShare = Math.floor(100 / count);
      Array.prototype.forEach.call(rows, function(el, i){
        var label = el.querySelector('.oc-label span'); if (label) label.textContent = 'Load Case ' + (i+1);
        var duty = el.querySelector('[data-field="duty_cycle"]');
        if (duty && (!duty.value || duty.dataset.auto === 'true' || count > 1)) {
           duty.value = (i === count - 1) ? (100 - (equalShare * (count - 1))) : equalShare;
           duty.dataset.auto = 'true';
        }
      });
      validateDutyCycles();
    }
    function validateDutyCycles(){
      var rows = wrap.querySelectorAll('.oc-row');
      var total = 0;
      rows.forEach(function(row){
        var val = parseFloat(row.querySelector('[data-field="duty_cycle"]').value) || 0;
        total += val;
      });
      var errEl = document.getElementById('bc-lc-error');
      if (total > 100) {
        if (errEl) {
          errEl.textContent = 'Total duty cycle percentage cannot exceed 100% (Current: ' + total + '%).';
          errEl.style.display = 'block';
        }
        return false;
      } else {
        if (errEl) errEl.style.display = 'none';
        return true;
      }
    }
    btn.addEventListener('click', function(){
      var idx = wrap.children.length + 1;
      wrap.appendChild(renderRow(idx));
      renumber();
      try { if (typeof toggleResultsVisibility === 'function') toggleResultsVisibility(); } catch(e){}
    });
    wrap.addEventListener('input', function(e){
      if (e.target && e.target.dataset.field === 'duty_cycle') {
        e.target.dataset.auto = 'false';
        validateDutyCycles();
        if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary();
      }
    });
    if (wrap.children.length === 0) {
      var firstRow = renderRow(1);
      wrap.appendChild(firstRow);
      renumber();
      // Pre-fill initial load case to match Inertia defaults
      var defaults = { radial_load: 12, axial_load: 30, speed: 3600, temperature: 25, duty_cycle: 100 };
      Object.keys(defaults).forEach(function(field){
        var inp = firstRow.querySelector('[data-field="' + field + '"]');
        if (inp) inp.value = defaults[field];
      });
    }
    try { if (typeof toggleResultsVisibility === 'function') toggleResultsVisibility(); } catch(e){}
  }
  // Smooth scroll to Operating Conditions with header offset
  function bcScrollToEvaluateOC(){
    try {
      var headerOffset = 142;
      var el = byId('operating-conditions') || byId('evaluate-panel');
      if (!el) return;
      var rect = el.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var top = rect.top + scrollTop - headerOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    } catch(e){}
  }
  window.bcScrollToEvaluateOC = bcScrollToEvaluateOC;
  function ensurePartData(pns, cb){
          try {
              var arr = Array.isArray(pns) ? pns.filter(Boolean) : [];
              window.BC_PARTS = window.BC_PARTS || {};
              var missing = arr.filter(function(pn){ return !window.BC_PARTS[pn]; });
              if (!missing.length) { if (cb) cb(); return; }
              var params = new URLSearchParams();
              params.set('action','nmbtc_bc_parts');
              params.set('nonce', (window.BEARINGS_CALCULATOR && window.BEARINGS_CALCULATOR.nonce) || '');
              missing.forEach(function(p){ params.append('parts[]', p); });
              fetch((window.BEARINGS_CALCULATOR && BEARINGS_CALCULATOR.ajax_url) || '/wp-admin/admin-ajax.php', {
                  method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:params.toString()
              }).then(function(r){ return r.json(); }).then(function(json){
                  try { console.log('[BC] nmbtc_bc_parts raw response:', JSON.stringify(json && json.data && json.data.parts)); } catch(e){}
                  if (json && json.success && json.data && json.data.parts) {
                      Object.keys(json.data.parts).forEach(function(pn){
                          var item = json.data.parts[pn] || {};
                          var f = (item && item.fields) ? item.fields : {};
                          var d = parseFloat(f.bore);
                          var D = parseFloat(f.outside_diameter);
                          var B = parseFloat(f.width);
                          var C = parseFloat(
                              f.dynamic_load_rating || f.basic_dynamic_load_rating_C || f.basic_dynamic_load_rating || f.Cr || f.C
                          );
                          var Co= parseFloat(
                              f.static_load_rating || f.basic_static_load_rating_C0 || f.basic_static_load_rating || f.C0 || f.C_0
                          );
                          var ref= parseFloat(f.reference_speed);
                          var lim= parseFloat(f.limiting_speed);
                          var Dw = parseFloat(f.ball_size_dw_mm);
                          var Z  = parseFloat(f.ball_complement_z);
                          var title = (item && item.title) ? String(item.title) : null;
                          var url = (item && item.url) ? String(item.url) : (title ? ('/parts/' + title.toLowerCase()) : null);
                          window.BC_PARTS[pn] = {
                              title: title,
                              url: url,
                              d: (isFinite(d)?d:null), D:(isFinite(D)?D:null), B:(isFinite(B)?B:null),
                              C:(isFinite(C)?C:null), Co:(isFinite(Co)?Co:null),
                              Dw:(isFinite(Dw)?Dw:null), Z:(isFinite(Z)?Z:null),
                              reference_speed:(isFinite(ref)?ref:null), limiting_speed:(isFinite(lim)?lim:null)
                          };
                          try { console.log('[BC] BC_PARTS['+pn+']:', JSON.stringify(window.BC_PARTS[pn]), '| raw fields:', JSON.stringify(f)); } catch(e){}
                      });
                  }
                  if (cb) cb();
              }).catch(function(){ if (cb) cb(); });
      } catch(e){ if (cb) cb(); }
  }
  // ── Dimension filter inputs (bore / OD / width) with mm/inch toggle ──────────
  function initDimensionFilters(){
    var currentUnit = 'mm';

    // Use real slugs + ranges from server if available, fall back to hardcoded defaults
    var ranges = (window.BC_DIM_RANGES && window.BC_DIM_RANGES.mm) ? window.BC_DIM_RANGES : {
      mm: {
        bore:  { slug: 'bore-diameter-mm',    min: null, max: null },
        od:    { slug: 'outside-diameter-mm', min: null, max: null },
        width: { slug: 'width-mm',            min: null, max: null }
      },
      'in': {
        bore:  { slug: 'bore-diameter-in',    min: null, max: null },
        od:    { slug: 'outside-diameter-in', min: null, max: null },
        width: { slug: 'width-in',            min: null, max: null }
      }
    };

    var slugMap = {
      mm:   { bore: ranges.mm.bore.slug,   od: ranges.mm.od.slug,   width: ranges.mm.width.slug   },
      'in': { bore: ranges['in'].bore.slug, od: ranges['in'].od.slug, width: ranges['in'].width.slug }
    };

    function applyPlaceholders(unit){
      var r = ranges[unit];
      var map = [
        { fromId: 'bc-bore-from',  toId: 'bc-bore-to',  dim: 'bore'  },
        { fromId: 'bc-od-from',    toId: 'bc-od-to',    dim: 'od'    },
        { fromId: 'bc-width-from', toId: 'bc-width-to', dim: 'width' }
      ];
      map.forEach(function(p){
        var fromEl = document.getElementById(p.fromId);
        var toEl   = document.getElementById(p.toId);
        var dimR   = r[p.dim];
        if (fromEl) { fromEl.placeholder = dimR.min !== null ? String(dimR.min) : 'Min'; }
        if (toEl)   { toEl.placeholder   = dimR.max !== null ? String(dimR.max) : 'Max'; }
      });
    }

    function triggerFilter(){
      syncHiddenFields();
      var applyLink = document.querySelector('.js-apply-filter');
      if (applyLink) {
        applyLink.click();
      } else {
        var form = document.getElementById('filter');
        if (form) {
          var evt = document.createEvent('Event');
          evt.initEvent('submit', true, true);
          form.dispatchEvent(evt);
        }
      }
    }

    var _debTimer = null;
    function debouncedTrigger(){
      clearTimeout(_debTimer);
      _debTimer = setTimeout(triggerFilter, 600);
    }

    function swapUnitColumns(unit){
      // Determine which column set to use
      var isMm = (unit === 'mm');
      var colSet = isMm ? (window.BC_COLUMNS_METRIC || []) : (window.BC_COLUMNS_INCH || []);

      // Filter: exclude columns whose slug ends with the opposite unit suffix
      var oppSuffix = isMm ? '-in' : '-mm';
      var filtered = colSet.filter(function(c){
        return !(c.slug && c.slug.slice(-oppSuffix.length) === oppSuffix);
      });

      // Swap hidden columns[] inputs in the form
      var form = document.getElementById('filter');
      if (form) {
        // Remove existing col inputs
        var old = form.querySelectorAll('.js-bc-col-input');
        Array.prototype.forEach.call(old, function(el){ el.parentNode.removeChild(el); });
        // Insert new unit col inputs before the first load-rating input so order is: unit cols → load rating cols
        var loadInput = form.querySelector('.js-bc-load-col-input');
        var anchor = loadInput || document.getElementById('bc-category-id');
        filtered.forEach(function(c){
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'columns[]';
          inp.value = c.id;
          inp.className = 'js-bc-col-input';
          inp.setAttribute('data-slug', c.slug);
          if (anchor) { form.insertBefore(inp, anchor); } else { form.appendChild(inp); }
        });
      }

      // Swap <thead> unit-dependent columns (keep load-rating cols in place)
      var thead = document.querySelector('.table thead tr');
      if (thead) {
        // Remove existing unit cols
        var oldTh = thead.querySelectorAll('.js-bc-unit-col');
        Array.prototype.forEach.call(oldTh, function(el){ el.parentNode.removeChild(el); });
        // Insert before the first load-rating th
        var loadTh = thead.querySelector('.js-bc-load-col');
        filtered.forEach(function(c){
          var th = document.createElement('th');
          th.setAttribute('data-id', c.id);
          th.className = 'js-bc-unit-col';
          th.setAttribute('data-slug', c.slug);
          th.innerHTML = '<div class="cell">' + (c.nice_name || c.label || '') + (c.unit ? ' ' + c.unit : '') + '</div>';
          if (loadTh) { thead.insertBefore(th, loadTh); } else { thead.appendChild(th); }
        });
      }
    }

    function setUnit(unit, skipClear){
      currentUnit = unit;
      // Update toggle button styles
      var btns = document.querySelectorAll('.bc-unit-btn');
      Array.prototype.forEach.call(btns, function(btn){
        var active = btn.getAttribute('data-unit') === unit;
        btn.style.background = active ? '#0d5cab' : '#fff';
        btn.style.color      = active ? '#fff'    : '#6b7280';
      });
      // Update unit labels
      var labels = document.querySelectorAll('.bc-unit-label');
      Array.prototype.forEach.call(labels, function(lbl){ lbl.textContent = unit; });
      // Update placeholders for new unit
      applyPlaceholders(unit);
      // Swap columns[] inputs and thead columns for the new unit
      swapUnitColumns(unit);
      // Clear inputs and hidden fields when switching units (skip on initial prefill)
      if (!skipClear) { clearDims(); }
    }

    function prefillFromUrl(){
      var params = new URLSearchParams(window.location.search);
      var slugs = slugMap[currentUnit];

      // Check if any inch params are present — if so, switch unit to 'in' first
      var inSlugs = slugMap['in'];
      var hasInch = params.get(inSlugs.bore + '_from') || params.get(inSlugs.bore + '_to') ||
                    params.get(inSlugs.od   + '_from') || params.get(inSlugs.od   + '_to') ||
                    params.get(inSlugs.width + '_from') || params.get(inSlugs.width + '_to');
      if (hasInch) {
        setUnit('in', true);
        slugs = slugMap['in'];
      }

      var pairs = [
        { fromId: 'bc-bore-from',  toId: 'bc-bore-to',  fromSlug: slugs.bore,  toSlug: slugs.bore  },
        { fromId: 'bc-od-from',    toId: 'bc-od-to',    fromSlug: slugs.od,    toSlug: slugs.od    },
        { fromId: 'bc-width-from', toId: 'bc-width-to', fromSlug: slugs.width, toSlug: slugs.width }
      ];
      pairs.forEach(function(p){
        var fromVal = params.get(p.fromSlug + '_from');
        var toVal   = params.get(p.toSlug   + '_to');
        var fromEl  = document.getElementById(p.fromId);
        var toEl    = document.getElementById(p.toId);
        if (fromEl && fromVal !== null) { fromEl.value = fromVal; }
        if (toEl   && toVal   !== null) { toEl.value   = toVal;   }
      });
      syncHiddenFields();
    }

    function clearDims(){
      ['bc-bore-from','bc-bore-to','bc-od-from','bc-od-to','bc-width-from','bc-width-to'].forEach(function(id){
        var el = document.getElementById(id);
        if (el) el.value = '';
      });
      syncHiddenFields();
    }

    function syncHiddenFields(){
      var container = document.getElementById('bc-dim-hidden-fields');
      if (!container) return;
      container.innerHTML = '';
      var slugs = slugMap[currentUnit];
      var pairs = [
        { fromId: 'bc-bore-from',  toId: 'bc-bore-to',  fromName: slugs.bore  + '_from', toName: slugs.bore  + '_to' },
        { fromId: 'bc-od-from',    toId: 'bc-od-to',    fromName: slugs.od    + '_from', toName: slugs.od    + '_to' },
        { fromId: 'bc-width-from', toId: 'bc-width-to', fromName: slugs.width + '_from', toName: slugs.width + '_to' }
      ];
      pairs.forEach(function(p){
        var fromEl = document.getElementById(p.fromId);
        var toEl   = document.getElementById(p.toId);
        var fromVal = fromEl ? fromEl.value.trim() : '';
        var toVal   = toEl   ? toEl.value.trim()   : '';
        if (fromVal !== '') {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.className = 'js-filter-control';
          inp.setAttribute('data-filter-type', 'range-from');
          inp.name  = p.fromName;
          inp.value = fromVal;
          container.appendChild(inp);
        }
        if (toVal !== '') {
          var inp2 = document.createElement('input');
          inp2.type = 'hidden';
          inp2.className = 'js-filter-control';
          inp2.setAttribute('data-filter-type', 'range-to');
          inp2.name  = p.toName;
          inp2.value = toVal;
          container.appendChild(inp2);
        }
      });
    }

    // Bind toggle buttons — switching unit triggers filter after clearing
    var toggleBtns = document.querySelectorAll('.bc-unit-btn');
    Array.prototype.forEach.call(toggleBtns, function(btn){
      btn.addEventListener('click', function(){
        setUnit(btn.getAttribute('data-unit'));
        triggerFilter();
      });
    });

    // Debounced input listeners on all six numeric inputs
    var dimInputIds = ['bc-bore-from','bc-bore-to','bc-od-from','bc-od-to','bc-width-from','bc-width-to'];
    dimInputIds.forEach(function(id){
      var el = document.getElementById(id);
      if (el) { el.addEventListener('input', debouncedTrigger); }
    });

    // "Clear All" button above the filter panel clears dimension inputs too
    var clearAllBtn = document.querySelector('.js-filter-clear');
    if (clearAllBtn){
      clearAllBtn.addEventListener('click', function(){
        clearDims();
      });
    }

    // Also sync before any filter.js submission (in case user presses Enter in part number search)
    var form = document.getElementById('filter');
    if (form){
      form.addEventListener('submit', function(){ syncHiddenFields(); });
    }

    // Set initial placeholders from ranges
    applyPlaceholders(currentUnit);

    // Prefill inputs from current URL query params (restores state after filter submission)
    prefillFromUrl();
  }

  function init(){
    // Guardrails for localized data
    try {
      if (!window.BEARINGS_CALCULATOR || !window.BEARINGS_CALCULATOR.categories || !window.BEARINGS_CALCULATOR.columns) {
        console.warn('[BearingsCalculatorUI] Missing BEARINGS_CALCULATOR.categories/columns. Filters may not update correctly.');
      }
    } catch(e){}
    // Avoid double-init if inline script already bound nav. We detect via a sentinel.
    if (document.documentElement.__bcUiInit) return;
    document.documentElement.__bcUiInit = true;
    initNav();
    initLoadCases();
    initModal();
    initSelection();
    initDimensionFilters();
      // Recompute summary when OC inputs change (debounced) and gate Results visibility
      var lcWrap = byId('load-cases-container');
      var __debTimer = null;
      function __debounce(fn, wait){
          return function(){
              var ctx=this, args=arguments;
              clearTimeout(__debTimer);
              __debTimer = setTimeout(function(){ fn.apply(ctx,args); }, wait);
          };
      }
      function hasCompleteLoadCase(){
          try {
              var rows = lcWrap ? Array.prototype.slice.call(lcWrap.children) : [];
              for (var i=0;i<rows.length;i++){
                  var inputs = rows[i].querySelectorAll('.lc-input');
                  if (inputs && inputs.length){
                      var ok = true;
                      inputs.forEach ? inputs.forEach(function(inp){ if (inp.value === '' || isNaN(parseFloat(inp.value))) ok = false; }) : Array.prototype.forEach.call(inputs, function(inp){ if (inp.value === '' || isNaN(parseFloat(inp.value))) ok = false; });
                      if (ok) return true;
                  }
              }
          } catch(e){}
          return false;
      }
      function toggleResultsVisibility(){
          var cont = byId('results-container');
          if (!cont) return;
          var show = hasCompleteLoadCase();
          // Always show the Results container, but toggle empty message vs. content
          cont.style.display = 'block';
          var msg = byId('results-empty-message');
          if (msg) msg.style.display = show ? 'none' : 'block';
          var ids = ['res-settings-grid','res-results-label','results-panel','results-kv-list'];
          ids.forEach(function(id){ var el = byId(id); if (!el) return; el.style.display = show ? '' : 'none'; });
      }
      var debUpd = __debounce(function(){
          toggleResultsVisibility();
          if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary();
      }, 200);
      if (lcWrap) {
          lcWrap.addEventListener('input', function(e){ if (e && e.target && e.target.classList && e.target.classList.contains('lc-input')) debUpd(); });
          lcWrap.addEventListener('change', function(e){ if (e && e.target && e.target.classList && e.target.classList.contains('lc-input')) debUpd(); });
      }

      // Select All logic (inline Calculations section)
      var selectAll = document.getElementById('calc-select-all');
      function getCalcChecks(){ return Array.prototype.slice.call(document.querySelectorAll('#calc-form input[type="checkbox"][name="calc[]"]')); }
      if (selectAll) {
          // initialize all to selected if Select All is checked by default
          if (selectAll.checked) {
              var initChecks = getCalcChecks();
              initChecks.forEach(function(cb){ cb.checked = true; });
          }
          if (!selectAll._bcBound) {
              selectAll._bcBound = true;
              selectAll.addEventListener('change', function(){
                  var checks = getCalcChecks();
                  checks.forEach(function(cb){ cb.checked = selectAll.checked; });
                  try { if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary(); } catch(e){}
              });
          }
          // Keep Select All in sync with individual items
          document.querySelectorAll('#calc-form input[type="checkbox"][name="calc[]"]').forEach(function(cb){
              if (cb._bcBound) return; cb._bcBound = true;
              cb.addEventListener('change', function(){
                  var checks = getCalcChecks();
                  var allChecked = checks.length && checks.every(function(x){ return x.checked; });
                  var noneChecked = checks.every(function(x){ return !x.checked; });
                  if (allChecked) { selectAll.checked = true; selectAll.indeterminate = false; }
                  else if (noneChecked) { selectAll.checked = false; selectAll.indeterminate = false; }
                  else { selectAll.checked = false; selectAll.indeterminate = true; }
                  try { if (typeof window.updateResultsSummary === 'function') window.updateResultsSummary(); } catch(e){}
              });
          });
      }

      // Collapsible toggles for OC, Calculations, and Results
      function bindCollapse(headerId, bodyId, toggleId){
          var h = byId(headerId), b = byId(bodyId), t = byId(toggleId);
          if (!h || !b) return;
          h.addEventListener('click', function(){
              var isOpen = b.style.display !== 'none';
              b.style.display = isOpen ? 'none' : 'block';
              if (t) t.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          });
      }
      bindCollapse('oc-header','oc-body','oc-toggle');
      bindCollapse('calcs-header','calcs-body','calcs-toggle');
      bindCollapse('res-header','res-body','res-toggle');

      // Initial gate for Results on load
      toggleResultsVisibility();

      // Render Inertia-style cards: one card per LC + optional Mean card
      function renderEvalCards(pn, cases, selectedCalcs){
          var lbl = 'background:#eef0f2; border:1px solid #d7d7d8; border-radius:6px; padding:12px; flex:1 1 55%; min-width:120px; overflow-wrap:break-word; word-break:break-word;';
          var val = 'background:#eef0f2; border:1px solid #d7d7d8; border-radius:6px; padding:12px; flex:1 1 40%; min-width:80px; overflow-wrap:break-word; word-break:break-word;';
          var valBold = val + ' font-weight:700;';
          var valPrimary = val + ' font-weight:700; color:#0d5cab; cursor:pointer;';
          var part = (window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
          var title = (part && part.title) ? part.title : pn;
          var partUrl = (part && part.url) ? part.url : (title ? ('/parts/' + String(title).toLowerCase()) : null);
          var sc = selectedCalcs || ['load_level','rating_life','static_safety','lubrication'];

          function lcCard(c){
              var v = c.values || {};
              var isMean = c.label === 'Mean';
              var cardStyle = isMean
                  ? 'border:2px solid rgba(13,92,171,.3); border-radius:8px; padding:16px; background:rgba(13,92,171,.05);'
                  : 'border:1px solid #e5e7eb; border-radius:8px; padding:16px;';
              var rows = '';
              // Settings section
              rows += '<div style="font-size:11px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:.05em; margin-bottom:8px;">'+(isMean ? 'Mean Results' : 'Settings')+'</div>';
              if (!isMean) {
                  // Part number links through to the part page (mirrors the Inertia Evaluate card)
                  var bearingCell = partUrl
                      ? '<a href="'+partUrl+'" style="'+valPrimary+' text-decoration:none; display:block;" title="View '+title+'">'+title+'</a>'
                      : '<span style="'+valPrimary+'">'+title+'</span>';
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">Bearing</span>'+bearingCell+'</div>';
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">Load Case</span><span style="'+val+'">'+c.label+'</span></div>';
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:14px;"><span style="'+lbl+'">Speed</span><span style="'+val+'">'+(v.speed||'-')+'</span></div>';
                  rows += '<div style="font-size:11px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:.05em; margin-bottom:8px;">Results</div>';
              }
              if (sc.indexOf('load_level') >= 0) {
                  var loadLabel = isMean ? 'Mean Equivalent Load (Pm)' : 'Dynamic Equivalent Radial Load';
                  var loadVal   = isMean ? (v.loadLevelCp||'-') : (v.loadLevelCp||'-');
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">'+loadLabel+'</span><span style="'+(isMean?valBold:val)+'">'+loadVal+'</span></div>';
              }
              if (sc.indexOf('rating_life') >= 0) {
                  var lifeLabel = isMean ? 'Mean Rating Life (L10m)' : 'Bearing Rating Life (L10)';
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">'+lifeLabel+'</span><span style="'+(isMean?valBold:val)+'">'+(v.ratingLife||'-')+'</span></div>';
              }
              if (!isMean && sc.indexOf('static_safety') >= 0) {
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">Static Safety Factor</span><span style="'+val+'">'+(v.staticSafety||'-')+'</span></div>';
              }
              if (!isMean && sc.indexOf('lubrication') >= 0) {
                  // Zero-based load-case index, so the grease dialog can recompute ndm/temperature for this card
                  var caseIdx = Math.max(0, (parseInt(String(c.label).replace(/^LC/, ''), 10) || 1) - 1);
                  rows += '<div style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-bottom:6px;"><span style="'+lbl+'">Recommended Grease</span><span class="kv-lube" data-pn="'+pn+'" data-case="'+caseIdx+'" title="Click for details" style="'+valPrimary+'">'+(v.lubrication||'-')+'</span></div>';
              }
              return '<div style="'+cardStyle+'">'+rows+'</div>';
          }

          // Separate mean from LC rows
          var lcRows = cases.filter(function(c){ return c.label !== 'Mean'; });
          var meanRow = cases.filter(function(c){ return c.label === 'Mean'; });
          var cards = lcRows.map(lcCard).concat(meanRow.map(lcCard));
          return cards.join('');
      }

      // Returns array of selected calc keys from the Calculations checkboxes
      function getSelectedCalcs(){
          var checks = document.querySelectorAll('#calc-form input[name="calc[]"]:checked');
          if (!checks || !checks.length) return ['load_level','rating_life','static_safety','lubrication'];
          return Array.prototype.map.call(checks, function(cb){ return cb.value; });
      }

      // Active bearing PN for the Evaluate panel (switches via selector pills)
      var evalActivePn = null;

      function renderBearingSelector(pns, activePn){
          if (pns.length <= 1) return '';
          return '<div id="eval-bearing-selector" style="display:flex; flex-wrap:wrap; gap:8px; margin-bottom:16px;">' +
              pns.map(function(pn){
                  var title = (window.BC_PARTS && window.BC_PARTS[pn] && window.BC_PARTS[pn].title) ? window.BC_PARTS[pn].title : pn;
                  var active = pn === activePn;
                  var style = active
                      ? 'padding:6px 14px; border-radius:6px; border:none; font-size:13px; font-weight:600; cursor:pointer; background:#0d5cab; color:#fff; box-shadow:0 2px 6px rgba(0,0,0,.15);'
                      : 'padding:6px 14px; border-radius:6px; border:none; font-size:13px; font-weight:600; cursor:pointer; background:#f3f4f6; color:#4b5563;';
                  return '<button type="button" class="eval-pn-btn" data-pn="'+pn+'" style="'+style+'">'+title+'</button>';
              }).join('') +
          '</div>';
      }

      // Populate Settings + key-value summary in Results to support multiple SKUs
      function updateResultsSummary(){
          try{
              // Prefer unified selection source and fall back to chips
              var pns = [];
              if (window.bcSelectedParts && typeof window.bcSelectedParts.forEach === 'function') {
                  window.bcSelectedParts.forEach(function(v){ if (v !== undefined && v !== null) pns.push(String(v)); });
              }
              if (!pns.length) {
                  var chips = Array.prototype.slice.call(document.querySelectorAll('#selection-chips .chip'));
                  pns = chips.map(function(c){ return c.getAttribute('data-pn') || c.textContent.trim(); }).filter(Boolean);
              }
              var list = document.getElementById('results-kv-list');
              if (!pns.length) {
                  if (list) list.innerHTML = '';
                  evalActivePn = null;
                  return;
              }

              // Ensure active PN is valid
              if (!evalActivePn || pns.indexOf(evalActivePn) < 0) evalActivePn = pns[0];

              // Ensure we have base specs for all
              ensurePartData(pns, function(){
                  // Read all load cases from rows
                  var casesWrap = document.getElementById('load-cases-container');
                  var rows = casesWrap ? casesWrap.querySelectorAll('.oc-row') : [];
                  var loadCases = Array.prototype.map.call(rows, function(row, idx){
                      var elR = row.querySelector('[data-field="radial_load"]');
                      var elA = row.querySelector('[data-field="axial_load"]');
                      var elS = row.querySelector('[data-field="speed"]');
                      var elT = row.querySelector('[data-field="temperature"]');
                      var elD = row.querySelector('[data-field="duty_cycle"]');
                      return { 
                        index: idx, 
                        Fr: elR ? parseFloat(elR.value) : NaN, 
                        Fa: elA ? parseFloat(elA.value) : NaN, 
                        n: elS ? parseFloat(elS.value) : NaN, 
                        T: elT ? parseFloat(elT.value) : NaN,
                        q: elD ? (parseFloat(elD.value) || 0) / 100 : 0
                      };
                  });
                  var totalQ = loadCases.reduce(function(acc, lc){ return acc + lc.q; }, 0);
                  if (totalQ > 1.0001) return; // Error handled by validateDutyCycles

                  if (!loadCases.length) loadCases = [{ index:0, Fr:NaN, Fa:NaN, n:NaN, T:NaN, q:1.0 }];

                  // Preliminary render: compute lubrication without waiting for DEL
                  try {
                    var preHtml = pns.map(function(pn){
                      if (pn !== evalActivePn) return '';
                      var data = (window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
                      var d  = data && Number.isFinite(data.d)  ? data.d  : NaN;
                      var D  = data && Number.isFinite(data.D)  ? data.D  : NaN;
                      var dm = (Number.isFinite(d) && Number.isFinite(D)) ? ((d+D)/2) : NaN;
                      var casesQuick = loadCases.map(function(lc){
                        var ndm_loc = (Number.isFinite(dm) && Number.isFinite(lc.n)) ? (dm * lc.n) : NaN;
                        var T = Number.isFinite(lc.T) ? lc.T : (window.BC_OVERRIDES && window.BC_OVERRIDES[pn] && window.BC_OVERRIDES[pn].operating_T_C);
                        if (!Number.isFinite(T)) T = 25;
                        var lubOv = (window.BC_OVERRIDES && window.BC_OVERRIDES[pn] && window.BC_OVERRIDES[pn].lubrication) || {};
                        var sel = bc_selectGrease({ ndm: ndm_loc, T: T, requireCond: !!lubOv.requireCond, plasticPresent: !!lubOv.plastic, noise: !!lubOv.noise, torque: !!lubOv.torque, cost: !!lubOv.cost });
                        var choice = (sel.scored && sel.scored[0] && sel.scored[0].g && sel.scored[0].g.code) || null;
                        // persist quick choice
                        window.BC_OVERRIDES = window.BC_OVERRIDES || {};
                        window.BC_OVERRIDES[pn] = window.BC_OVERRIDES[pn] || {};
                        window.BC_OVERRIDES[pn].lubrication = window.BC_OVERRIDES[pn].lubrication || {};
                        if (choice) window.BC_OVERRIDES[pn].lubrication.choice = choice;
                        return {
                          label: 'LC'+(lc.index+1),
                          P: null,
                          L10h: null,
                          values: {
                            loadLevelCp: '-',
                            ratingLife: '-',
                            staticSafety: '-',
                            lubrication: (choice || '-'),
                            friction: '-',
                            speed: (Number.isFinite(lc.n)? lc.n.toFixed(0)+' rpm' : '-'),
                            freq: (Number.isFinite(lc.n)? (lc.n/60).toFixed(2)+' Hz' : '-')
                          }
                        };
                      });
                      var sc = getSelectedCalcs();
                      return renderEvalCards(pn, casesQuick, sc);
                    }).join('');
                    if (list) list.innerHTML = renderBearingSelector(pns, evalActivePn) + '<div style="display:grid; grid-template-columns:repeat(auto-fill,minmax(360px,1fr)); gap:16px;">'+preHtml+'</div>';
                  } catch(e){}

                  function getDELForCase(pn, lc){
                      return new Promise(function(resolve){
                          try{
                              var store = (window.BC_OVERRIDES = window.BC_OVERRIDES || {});
                              store[pn] = store[pn] || {};
                              store[pn].cases = store[pn].cases || {};
                              var c = (store[pn].cases[lc.index] = store[pn].cases[lc.index] || { inputs:{}, computed:{} });
                              // Invalidate cached P_N if inputs have changed since last computation
                              var prev = c.inputs || {};
                              if (prev.Fr !== lc.Fr || prev.Fa !== lc.Fa) {
                                  c.computed.P_N = undefined;
                              }
                              // Persist per-case inputs including temperature so other UIs (e.g., grease modal) can compute ndm and temp correctly
                              c.inputs = { Fr: lc.Fr, Fa: lc.Fa, n: lc.n, T: lc.T };
                              if (Number.isFinite(c.computed.P_N)) { resolve(c.computed.P_N); return; }
                              // Compute client-side using bearing specs from BC_PARTS
                              var data = (window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
                              var json = bc_calculateDEL(data, { radial_load: Number.isFinite(lc.Fr)?lc.Fr:0, axial_load: Number.isFinite(lc.Fa)?lc.Fa:0 });
                              if (json && json.success) {
                                  c.computed.P_N = json.dynamic_equivalent_load;
                                  c.computed.X = json.X_factor; c.computed.Y = json.Y_factor; c.computed.e = json.e_factor;
                              } else {
                                  c.computed.P_N = null;
                              }
                              resolve(c.computed.P_N);
                          }catch(e){ resolve(null); }
                      });
                  }

                  var allPromises = [];
                  loadCases.forEach(function(lc){ pns.forEach(function(pn){ allPromises.push(getDELForCase(pn, lc)); }); });

                  Promise.all(allPromises).then(function(){
                      var html = pns.map(function(pn){
                          if (pn !== evalActivePn) return '';
                          var data = (window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
                          var casesArr = (window.BC_OVERRIDES && window.BC_OVERRIDES[pn] && window.BC_OVERRIDES[pn].cases) || {};
                          var computedPerCase = loadCases.map(function(lc){
                              var C  = data && Number.isFinite(data.C)  ? data.C  : NaN;
                              var Co = data && Number.isFinite(data.Co) ? data.Co : NaN;
                              var d  = data && Number.isFinite(data.d)  ? data.d  : NaN;
                              var D  = data && Number.isFinite(data.D)  ? data.D  : NaN;

                              var entry = casesArr[lc.index] || { inputs: lc, computed: {} };
                              var P  = Number.isFinite(entry.computed.P_N) ? entry.computed.P_N : NaN;
                              var n  = lc.n;
                              var Fr = lc.Fr; var Fa = lc.Fa;

                              var pr = Number.isFinite(P) ? (P + ' N') : '-';
                              var L10   = (Number.isFinite(C) && Number.isFinite(P) && P>0) ? Math.pow(C/P, 3) : NaN;
                              var L10h  = (Number.isFinite(L10) && Number.isFinite(n) && n>0) ? ((1e6/(60*n))*L10) : NaN;

                              entry.computed.P = P;
                              entry.computed.L10h = L10h;
                              entry.computed.q = lc.q;

                              var life  = Number.isFinite(L10h) ? (Math.round(L10h).toLocaleString() + ' h') : '-';

                              var X0=0.6, Y0=0.5;
                              var P0_candidate = (Number.isFinite(Fr)?X0*Fr:0) + (Number.isFinite(Fa)?Y0*Fa:0);
                              var P0 = (Number.isFinite(Fr)||Number.isFinite(Fa)) ? Math.max(Number.isFinite(Fr)?Fr:0, P0_candidate) : NaN;
                              var fs = (Number.isFinite(Co) && Number.isFinite(P0) && P0>0) ? (Co/P0).toFixed(2) : '-';

                              var dm = (Number.isFinite(d) && Number.isFinite(D)) ? ((d+D)/2) : NaN;
                              var f0=0.02, f1=1e-4, nu=20;
                              var M0=(Number.isFinite(n)&&Number.isFinite(dm))?(1e-7*f0*nu*n*Math.pow(dm,3)):NaN;
                              var M1=(Number.isFinite(dm)?(f1*((Number.isFinite(Fr)?Fr:0)+0.5*(Number.isFinite(Fa)?Fa:0))*dm):NaN);
                              var M=(Number.isFinite(M0)?M0:0)+(Number.isFinite(M1)?M1:0);
                              var Ploss=(Number.isFinite(n)&&Number.isFinite(M))?((2*Math.PI/60)*n*(M/1000)):NaN;

                              // Compute lubrication per-case
                              var dm_loc = (Number.isFinite(d) && Number.isFinite(D)) ? ((d+D)/2) : NaN;
                              var ndm_loc = (Number.isFinite(dm_loc) && Number.isFinite(n)) ? (dm_loc * n) : NaN;
                              // Prefer per-load-case temperature; fall back to per-part override, then ambient
                              var T = Number.isFinite(lc.T) ? lc.T : (window.BC_OVERRIDES && window.BC_OVERRIDES[pn] && window.BC_OVERRIDES[pn].operating_T_C);
                              if (typeof T === 'string') { var __Tf = parseFloat(T); if (Number.isFinite(__Tf)) T = __Tf; }
                              if (!Number.isFinite(T)) T = 25;
                              var lubOv = (window.BC_OVERRIDES && window.BC_OVERRIDES[pn] && window.BC_OVERRIDES[pn].lubrication) || {};
                              var sel = bc_selectGrease({ ndm: ndm_loc, T: T, requireCond: !!lubOv.requireCond, plasticPresent: !!lubOv.plastic, noise: !!lubOv.noise, torque: !!lubOv.torque, cost: !!lubOv.cost });
                              var lubricationChoice = (sel.scored && sel.scored[0] && sel.scored[0].g && sel.scored[0].g.code) || null;
                              if (!window.BC_OVERRIDES) window.BC_OVERRIDES = {};
                              if (!window.BC_OVERRIDES[pn]) window.BC_OVERRIDES[pn] = {};
                              window.BC_OVERRIDES[pn].lubrication = window.BC_OVERRIDES[pn].lubrication || {};
                              window.BC_OVERRIDES[pn].lubrication.choice = lubricationChoice;
                              window.BC_OVERRIDES[pn].cases = window.BC_OVERRIDES[pn].cases || {};
                              window.BC_OVERRIDES[pn].cases[lc.index] = window.BC_OVERRIDES[pn].cases[lc.index] || { inputs:{}, computed:{} };
                              window.BC_OVERRIDES[pn].cases[lc.index].computed.lubrication_choice = lubricationChoice;

                              return {
                                  label: 'LC'+(lc.index+1),
                                  values: {
                                      loadLevelCp: pr,
                                      ratingLife: life,
                                      staticSafety: fs,
                                      lubrication: (lubricationChoice || '-'),
                                      friction: (Number.isFinite(Ploss)? Ploss.toFixed(2)+' W' : '-'),
                                      speed: (Number.isFinite(n)? n.toFixed(0)+' rpm' : '-'),
                                      freq:  (Number.isFinite(n)? (n/60).toFixed(2)+' Hz' : '-')
                                  }
                              };
                          });

                          // Mean Life Calculation for Legacy Layout
                          var validEntries = computedPerCase.filter(function(c, i){
                              var entry = casesArr[i];
                              return entry && Number.isFinite(entry.computed.P) && Number.isFinite(entry.computed.L10h) && Number.isFinite(entry.computed.q);
                          });

                          if (validEntries.length > 1) {
                              var sumNiQi = 0;
                              var numerator = 0;
                              validEntries.forEach(function(c, i){
                                  var entry = casesArr[i];
                                  var n_val = entry.inputs.n || 0;
                                  var q_val = entry.computed.q;
                                  var P_val = entry.computed.P;
                                  sumNiQi += n_val * q_val;
                                  numerator += Math.pow(P_val, 3) * n_val * q_val;
                              });

                              if (sumNiQi > 0) {
                                  var Pm = Math.pow(numerator / sumNiQi, 1/3);
                                  var C_val = data && Number.isFinite(data.C) ? data.C : NaN;
                                  var L10m = (Number.isFinite(C_val) && C_val > 0) ? (Math.pow(10, 6) / (60 * sumNiQi)) * Math.pow(C_val / Pm, 3) : null;

                                  computedPerCase.push({
                                      label: 'Mean',
                                      values: {
                                          loadLevelCp: Pm.toFixed(1) + ' N',
                                          ratingLife: L10m != null ? Math.round(L10m).toLocaleString() + ' h' : '-',
                                          staticSafety: '-',
                                          lubrication: '-',
                                          friction: '-',
                                          speed: '-',
                                          freq: '-'
                                      }
                                  });
                              }
                          }

                          var sc = getSelectedCalcs();
                          return renderEvalCards(pn, computedPerCase, sc);
                      }).join('');
                      if (list) list.innerHTML = renderBearingSelector(pns, evalActivePn) + '<div style="display:grid; grid-template-columns:repeat(auto-fill,minmax(360px,1fr)); gap:16px;">'+html+'</div>';
                      // Update top-level lubrication display based on computed choice
                      try {
                        var lubeEl2 = document.getElementById('res-setting-lube');
                        var first = pns[0];
                        if (lubeEl2 && first && window.BC_OVERRIDES && window.BC_OVERRIDES[first] && window.BC_OVERRIDES[first].lubrication && window.BC_OVERRIDES[first].lubrication.choice) {
                          lubeEl2.textContent = window.BC_OVERRIDES[first].lubrication.choice;
                        }
                      } catch(e){}
                  });
              });
          }catch(e){}
      }
      // Expose for other handlers
      window.updateResultsSummary = updateResultsSummary;

      // Bearing selector pill clicks (delegated on results-kv-list)
      (function(){
        var list = document.getElementById('results-kv-list');
        if (!list) return;
        list.addEventListener('click', function(e){
          var btn = e.target && e.target.closest && e.target.closest('.eval-pn-btn');
          if (!btn) return;
          var pn = btn.getAttribute('data-pn');
          if (pn && pn !== evalActivePn) {
            evalActivePn = pn;
            try { updateResultsSummary(); } catch(ex){}
          }
        });
      })();

      // Re-render when calc checkboxes change
      (function(){
        var form = document.getElementById('calc-form');
        if (!form) return;
        form.addEventListener('change', function(){
          try { updateResultsSummary(); } catch(e){}
        });
      })();

      // Grease recommendation click: navigate to lubrication panel (delegated)
      (function(){
        var list = document.getElementById('results-kv-list');
        if (!list || list.__boundKvLube) return; list.__boundKvLube = true;
        list.addEventListener('click', function(e){
          var lube = e.target && e.target.closest && e.target.closest('.kv-lube');
          if (lube) {
            var pn = lube.getAttribute('data-pn');
            try { setActiveNav('evaluate'); } catch(e){}
            try {
              var btab = pn ? document.querySelector('#bc-tabs-bearings [data-bearing="'+pn+'"]') : null;
              if (btab) btab.click();
              var ltab = document.querySelector('#bc-tabs-calcs [data-calc="lubrication"]');
              if (ltab) ltab.click();
              var panel = document.getElementById('bc-panel');
              if (panel && panel.scrollIntoView) panel.scrollIntoView({behavior:'smooth', block:'start'});
            } catch(e){}
          }
        });
      })();

      // Continue button: close modal and populate Results calc tabs
      var contBtn = document.getElementById('calc-modal-continue');
      if (contBtn) {
          contBtn.addEventListener('click', function(){
              var checks = getCalcChecks().filter(function(cb){ return cb.checked; });
              // Build labels from sibling strong text
              var selected = checks.map(function(cb){
                  var label = cb.closest('label');
                  var titleEl = label ? label.querySelector('strong') : null;
                  var title = titleEl ? titleEl.textContent.trim() : (cb.value || 'Calc');
                  return { key: cb.value, title: title };
              });
              // Close modal
              if (window.__bcModal && typeof window.__bcModal.close === 'function') window.__bcModal.close();
              // Populate tabs
              var tabsCalcs = document.getElementById('bc-tabs-calcs');
              var tabsBearings = document.getElementById('bc-tabs-bearings');
              var panel = document.getElementById('bc-panel');
              if (!tabsCalcs || !panel || !tabsBearings) return;
              tabsCalcs.innerHTML = '';
              tabsBearings.innerHTML = '';

              // Gather selected bearings using shared selection state; refuse to proceed without real selections
              var bearings = [];
              try {
                  if (window.BC_SELECTED && window.BC_SELECTED.size) {
                      bearings = Array.from(window.BC_SELECTED);
                  } else if (window.bcSelectedParts && window.bcSelectedParts.size) {
                      bearings = Array.from(window.bcSelectedParts);
                  }
              } catch(e) {}
              if (!bearings.length) { alert('Please select at least one bearing from the search results.'); return; }

              // Active state holders
              var active = { bearing: bearings[0], calc: (selected[0] ? selected[0].key : 'load_level') };

              // Ensure product data for selected bearings, then render
              ensurePartData(bearings, function(){
                  proceedRender();
              });

              function proceedRender(){

                  function styleAsTab(btn, isActive){
                      btn.className = 'bc-tab';
                      btn.style.cssText = 'padding:.35rem .6rem; border:1px solid #d7dee7; border-radius:6px; background:'+(isActive?'#eef5ff':'#fff')+'; color:'+(isActive?'#0d5cab':'#374151')+';';
                  }

                  function renderPanel(calcKey, bearing){
                      // ensure overrides store exists
                      if (!window.BC_OVERRIDES) { window.BC_OVERRIDES = {}; }
                      if (!window.BC_OVERRIDES[bearing]) { window.BC_OVERRIDES[bearing] = {}; }
                      if (!window.BC_OVERRIDES[bearing][calcKey]) { window.BC_OVERRIDES[bearing][calcKey] = {}; }
                      var ov = window.BC_OVERRIDES[bearing][calcKey];
                      // read last Load Case values (placeholder for future calculations)
                      var lc = { radial:null, axial:null, speed:null, temp:null, duty:null };
                      var casesWrap = document.getElementById('load-cases-container');
                      if (casesWrap && casesWrap.lastElementChild) {
                          var elR = casesWrap.querySelector('[data-field="radial_load"]');
                          var elA = casesWrap.querySelector('[data-field="axial_load"]');
                          var elS = casesWrap.querySelector('[data-field="speed"]');
                          var elT = casesWrap.querySelector('[data-field="temperature"]');
                          var elD = casesWrap.querySelector('[data-field="duty_cycle"]');
                          lc.radial = elR && elR.value !== undefined ? elR.value : '';
                          lc.axial  = elA && elA.value !== undefined ? elA.value : '';
                          lc.speed  = elS && elS.value !== undefined ? elS.value : '';
                          lc.temp   = elT && elT.value !== undefined ? elT.value : '';
                          lc.duty   = elD && elD.value !== undefined ? elD.value : '';
                      }
                      var title = '<div style="margin-bottom:6px;"><strong>PN:</strong> '+(bearing||'—')+' &nbsp; | &nbsp; <strong>Calc:</strong> '+ calcKey.replace('_',' ') +'</div>';
                      var content = '';
                      switch (calcKey) {
                          case 'load_level':
                              (function(){
                                  var Fr_N = parseFloat(lc.radial || '');
                                  var Fa_N = parseFloat(lc.axial || '');
                                  var valid = isFinite(Fr_N) && isFinite(Fa_N);
                                  var parts = [];
                                  parts.push('<strong>Load Level</strong>');
                                  if (!valid) {
                                      parts.push('<div style="color:#b91c1c;">Enter Radial and Axial loads in Operating Conditions to evaluate.</div>');
                                      content = parts.join('');
                                      panel.innerHTML = title + content;
                                      return; // early-exit IIFE; avoid invalid break
                                  }
                                  var sub = [];
                                  var bearingPN = bearing;
                                  var data = (window.BC_PARTS && window.BC_PARTS[bearingPN]) ? window.BC_PARTS[bearingPN] : null;
                                  var json = bc_calculateDEL(data, { radial_load: isFinite(Fr_N)?Fr_N:0, axial_load: isFinite(Fa_N)?Fa_N:0 });
                                  if (json && json.success) {
                                      var P_N = json.dynamic_equivalent_load;
                                      var X = json.X_factor, Y = json.Y_factor, e = json.e_factor;
                                      window.BC_OVERRIDES[bearingPN].load_level = window.BC_OVERRIDES[bearingPN].load_level || {};
                                      window.BC_OVERRIDES[bearingPN].load_level.P_N = P_N;
                                      window.BC_OVERRIDES[bearingPN].load_level.X = X;
                                      window.BC_OVERRIDES[bearingPN].load_level.Y = Y;
                                      window.BC_OVERRIDES[bearingPN].load_level.e = e;
                                      window.BC_OVERRIDES[bearingPN].load_level.error = null;
                                      sub.push('<div>Fa/Fr ' + (isFinite(Fr_N)&&Fr_N!==0 ? '= ' + (Fa_N/Fr_N).toFixed(3) : '') + (isFinite(e)? ('; threshold e = ' + (+e).toFixed(2)):'') + '</div>');
                                      sub.push('<div>'+(json.formula || 'P = X·Fr + Y·Fa')+'</div>');
                                      sub.push('<div>P = '+(+X).toFixed(2)+'·'+Fr_N.toFixed(0)+' + '+(+Y).toFixed(2)+'·'+Fa_N.toFixed(0)+' = <strong>'+P_N.toFixed(0)+'</strong> N</div>');
                                      var C = data && Number.isFinite(data.C) ? data.C : NaN;
                                      if (isFinite(C) && isFinite(P_N) && P_N>0) {
                                          var cp = C / P_N; var pmin = 0.02*C;
                                          sub.push('<div>C/P = <strong>'+cp.toFixed(2)+'</strong> (C='+C.toFixed(0)+' N)</div>');
                                          if (P_N < pmin) sub.push('<div style="color:#92400e; background:#fffbeb; border:1px solid #f59e0b; padding:6px 8px; border-radius:6px; margin-top:6px;">Warning: P ('+P_N.toFixed(0)+' N) is below ~2%·C ('+pmin.toFixed(0)+' N). Risk of skidding.</div>');
                                      } else {
                                          sub.push('<div style="color:#6b7280; font-size:12px;">C/P unavailable (dynamic rating not in dataset).</div>');
                                      }
                                  } else {
                                      var msg = (json && json.error) || 'Dynamic equivalent load could not be computed.';
                                      window.BC_OVERRIDES[bearingPN].load_level = window.BC_OVERRIDES[bearingPN].load_level || {};
                                      window.BC_OVERRIDES[bearingPN].load_level.P_N = null;
                                      window.BC_OVERRIDES[bearingPN].load_level.error = msg;
                                      sub.push('<div style="color:#b91c1c; background:#fee2e2; border:1px solid #fca5a5; padding:8px; border-radius:6px;">'+msg+' Please map Ball size (Dw) and Ball complement (Z) for this part in Admin.</div>');
                                  }
                                  parts.push(sub.join(''));
                                  var oc = '<div style="margin-top:10px; padding:8px; background:#f9fafb; border:1px solid #eee; border-radius:6px;">'
                                    + '<div style="font-weight:600; margin-bottom:4px;">Operating Conditions</div>'
                                    + '<div style="display:grid; grid-template-columns: repeat(auto-fit,minmax(140px,1fr)); gap:6px; font-size:12px; color:#374151;">'
                                    + '<div>Radial: '+(lc.radial||'—')+' N</div><div>Axial: '+(lc.axial||'—')+' N</div><div>Speed: '+(lc.speed||'—')+' r/min</div>'
                                    + '</div></div>';
                                  parts.push(oc);
                                  content = parts.join('');
                              })();
                              break;
                          case 'rating_life':
                              (function(){
                                  var data = (window.BC_PARTS && window.BC_PARTS[bearing]) ? window.BC_PARTS[bearing] : null;
                                  // read overrides from previous render if present
                                  var elC = document.getElementById('rl_C');
                                  var elPexp = document.getElementById('rl_p');
                                  var C = Number.isFinite(ov.C) ? ov.C : (elC && elC.value !== '' ? parseFloat(elC.value) : (data && Number.isFinite(data.C) ? data.C : NaN));
                                  // Use P from Load Level (server-derived). Do not recompute here.
                                  var n = parseFloat(lc.speed || '');
                                  var P = (window.BC_OVERRIDES && window.BC_OVERRIDES[bearing] && window.BC_OVERRIDES[bearing].load_level && isFinite(window.BC_OVERRIDES[bearing].load_level.P_N)) ? window.BC_OVERRIDES[bearing].load_level.P_N : NaN;
                                  var lastErr = (window.BC_OVERRIDES && window.BC_OVERRIDES[bearing] && window.BC_OVERRIDES[bearing].load_level && window.BC_OVERRIDES[bearing].load_level.error) || null;
                                  var p = Number.isFinite(ov.p) ? ov.p : (elPexp && elPexp.value !== '' ? parseFloat(elPexp.value) : 3.0); // ball bearings default
                                  var parts = [];
                                  parts.push('<strong>Bearing Rating Life</strong>');
                                  // Inline inputs
                                  var initC = Number.isFinite(C) ? C : '';
                                  var initP = Number.isFinite(p) ? p : 3.0;
                                  parts.push('<div style="margin:6px 0; display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:8px;">'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Dynamic rating C (N)<input id="rl_C" type="number" step="any" value="'+initC+'"></label>'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Life exponent p<input id="rl_p" type="number" step="any" value="'+initP+'"></label>'
                                      +'</div>');
                                  if (!(Number.isFinite(C) && Number.isFinite(P) && P>0)) {
                                      var why = Number.isFinite(C) ? (lastErr || 'Dynamic equivalent load (P) is unavailable. Compute Load Level first.') : 'Need dynamic rating C and computed load P to evaluate life.';
                                      console.error('[BC][Life] Cannot compute life', { bearing: bearing, C: C, P: P, lastDELerror: lastErr });
                                      parts.push('<div style="color:#b91c1c; background:#fee2e2; border:1px solid #fca5a5; padding:8px; border-radius:6px;">'+why+'</div>');
                                  } else {
                                      var L10 = Math.pow(C/P, p); // million rev
                                      var L10h = Number.isFinite(n) && n>0 ? ((1e6 / (60*n)) * L10) : NaN; // hours
                                      parts.push('<div>C = '+C.toFixed(0)+' N, P = '+P.toFixed(2)+' N, p = '+p.toFixed(2)+'</div>');
                                      parts.push('<div>L10 = (C/P)^p = <strong>'+L10.toFixed(2)+'</strong> million rev</div>');
                                      parts.push('<div>L10h = <strong>'+(Number.isFinite(L10h)?L10h.toFixed(1):'—')+'</strong> hours'+(Number.isFinite(n)&&n>0?' at '+n.toFixed(0)+' rpm':'')+'</div>');
                                  }
                                  parts.push('<div style="color:#6b7280; font-size:12px;">Later: reliability a1, lubrication/contamination modifiers.</div>');
                                  content = parts.join('');
                              })();
                              break;
                          case 'speed_level':
                              (function(){
                                  var data = (window.BC_PARTS && window.BC_PARTS[bearing]) ? window.BC_PARTS[bearing] : null;
                                  var n = parseFloat(lc.speed || '');
                                  var d = data && Number.isFinite(data.d) ? data.d : NaN;
                                  var D = data && Number.isFinite(data.D) ? data.D : NaN;
                                  var valid = isFinite(n) && isFinite(d) && isFinite(D);
                                  var dm = valid ? ((d + D)/2.0) : NaN;
                                  var ndm = valid ? (n * dm) : NaN;
                                  // read overrides or use dataset
                                  var elRS = document.getElementById('sl_rs');
                                  var elLS = document.getElementById('sl_ls');
                                  var rs = Number.isFinite(ov.rs) ? ov.rs : (elRS && elRS.value !== '' ? parseFloat(elRS.value) : (data && Number.isFinite(data.reference_speed) ? data.reference_speed : null));
                                  var ls = Number.isFinite(ov.ls) ? ov.ls : (elLS && elLS.value !== '' ? parseFloat(elLS.value) : (data && Number.isFinite(data.limiting_speed) ? data.limiting_speed : null));
                                  var pctRef = (rs && n) ? (100*n/rs) : null;
                                  var pctLim = (ls && n) ? (100*n/ls) : null;
                                  var parts = [];
                                  parts.push('<strong>Speed Level</strong>');
                                  // Inline inputs
                                  var initRS = Number.isFinite(rs) ? rs : '';
                                  var initLS = Number.isFinite(ls) ? ls : '';
                                  parts.push('<div style="margin:6px 0; display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:8px;">'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Reference speed (rpm)<input id="sl_rs" type="number" step="any" value="'+initRS+'"></label>'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Limiting speed (rpm)<input id="sl_ls" type="number" step="any" value="'+initLS+'"></label>'
                                      +'</div>');
                                  if (!valid) {
                                      parts.push('<div style="color:#b91c1c;">Enter Speed (rpm) and select a bearing with d and D available.</div>');
                                  } else {
                                      parts.push('<div>dm = (d + D)/2 = ('+d.toFixed(2)+' + '+D.toFixed(2)+')/2 = <strong>'+dm.toFixed(2)+'</strong> mm</div>');
                                      parts.push('<div>ndm = n × dm = '+n.toFixed(0)+' × '+dm.toFixed(2)+' = <strong>'+ndm.toFixed(0)+'</strong> mm·rpm</div>');
                                      if (Number.isFinite(rs)) {
                                          parts.push('<div>Reference speed = '+rs.toFixed(0)+' rpm ('+(Number.isFinite(pctRef)?pctRef.toFixed(0)+'%':'—')+')</div>');
                                      }
                                      if (Number.isFinite(ls)) {
                                          var color = (Number.isFinite(pctLim) && pctLim>100) ? '#b91c1c' : '#0d9488';
                                          parts.push('<div>Limiting speed = '+ls.toFixed(0)+' rpm ('+(Number.isFinite(pctLim)?('<span style="color:'+color+'">'+pctLim.toFixed(0)+'%</span>'):'—')+')</div>');
                                      }
                                  }
                                  content = parts.join('');
                              })(); break;
                          case 'static_safety':
                              (function(){
                                  var data = (window.BC_PARTS && window.BC_PARTS[bearing]) ? window.BC_PARTS[bearing] : null;
                                  // read overrides from previous render if present
                                  var elCo = document.getElementById('ss_Co');
                                  var elX0 = document.getElementById('ss_X0');
                                  var elY0 = document.getElementById('ss_Y0');
                                  var Co = elCo && elCo.value !== '' ? parseFloat(elCo.value) : (data && Number.isFinite(data.Co) ? data.Co : NaN);
                                  var Fr = parseFloat(lc.radial || '');
                                  var Fa = parseFloat(lc.axial || '');
                                  var X0 = elX0 && elX0.value !== '' ? parseFloat(elX0.value) : 0.6;
                                  var Y0 = elY0 && elY0.value !== '' ? parseFloat(elY0.value) : 0.5; // deep-groove ball bearing typical
                                  var P0_cand = (isFinite(Fr)||isFinite(Fa)) ? ((isFinite(Fr)?X0*Fr:0) + (isFinite(Fa)?Y0*Fa:0)) : NaN;
                                  var P0 = Number.isFinite(P0_cand) ? Math.max(isFinite(Fr)?Fr:0, P0_cand) : NaN;
                                  var S0 = (Number.isFinite(Co) && Number.isFinite(P0) && P0>0) ? (Co/P0) : NaN;
                                  var parts = [];
                                  parts.push('<strong>Static Safety</strong>');
                                  // Inline inputs
                                  var initCo = Number.isFinite(Co) ? Co : '';
                                  parts.push('<div style="margin:6px 0; display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:8px;">'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Static rating Co (N)<input id="ss_Co" type="number" step="any" value="'+initCo+'"></label>'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">X0<input id="ss_X0" type="number" step="any" value="'+X0+'"></label>'
                                      +'<label style="font-size:12px; color:#374151; display:flex; flex-direction:column; gap:4px;">Y0<input id="ss_Y0" type="number" step="any" value="'+Y0+'"></label>'
                                      +'</div>');
                                  parts.push('<div style="color:#555;">P0 = X0·Fr + Y0·Fa with X0='+X0+', Y0='+Y0+'.</div>');
                                  parts.push('<div>Co = <strong>'+(Number.isFinite(Co)?Co.toFixed(0):'—')+'</strong> N</div>');
                                  parts.push('<div>P0 = <strong>'+(Number.isFinite(P0)?P0.toFixed(2):'—')+'</strong> N</div>');
                                  if (Number.isFinite(S0)) {
                                      var threshold = 1.0; var thresholdShock = 1.5;
                                      var verdict = S0>=threshold ? 'PASS' : 'FAIL';
                                      parts.push('<div>S0 = Co/P0 = <strong>'+S0.toFixed(2)+'</strong> → '+verdict+'</div>');
                                      parts.push('<div style="color:#6b7280; font-size:12px;">Guideline: S0 ≥ '+threshold+' (≥ '+thresholdShock+' if shock/vibration).</div>');
                                  } else {
                                      parts.push('<div style="color:#b91c1c;">Need Co (static rating) and loads to compute S0.</div>');
                                  }
                                  content = parts.join('');
                              })();
                              break;
                          case 'lubrication':
                              (function(){
                                  // Grease selection with dataset and preferences
                                  // 1) read inputs and compute ndm
                                  var data = (window.BC_PARTS && window.BC_PARTS[bearing]) ? window.BC_PARTS[bearing] : null;
                                  var n = parseFloat(lc.speed || '');
                                  var T = parseFloat(lc.temp || '');
                                  var d = data && Number.isFinite(data.d) ? data.d : NaN;
                                  var D = data && Number.isFinite(data.D) ? data.D : NaN;
                                  var dm = (isFinite(d) && isFinite(D)) ? ((d+D)/2.0) : NaN;
                                  var ndm = (isFinite(n) && isFinite(dm)) ? n*dm : NaN;
                                  // viscosity context (kept from previous placeholder)
                                  var nu = 20; // cSt assumed
                                  var nu1 = isFinite(ndm) ? Math.max(5, Math.min(60, 20000/Math.sqrt(ndm))) : NaN; // cSt
                                  var kappa = (isFinite(nu) && isFinite(nu1) && nu1>0) ? (nu/nu1) : NaN;
                                  var regime = 'unknown';
                                  if (isFinite(kappa)) {
                                      if (kappa < 1) regime = 'Boundary/Mixed'; else if (kappa < 4) regime = 'Mixed/Full'; else regime = 'Full film';
                                  }
                                  // 3) overrides (preferences)
                                  var ov = (window.BC_OVERRIDES && window.BC_OVERRIDES[bearing] && window.BC_OVERRIDES[bearing]['lubrication']) ? window.BC_OVERRIDES[bearing]['lubrication'] : {};
                                  var requireCond = !!ov.requireCond;
                                  var plasticPresent = !!ov.plastic;
                                  var costSensitive = !!ov.cost;
                                  var lowNoise = !!ov.noise;
                                  var lowTorque = !!ov.torque;

                                  var parts = [];
                                  parts.push('<strong>Lubrication</strong>');
                                  if (!isFinite(ndm)) {
                                      parts.push('<div style="color:#b91c1c;">Enter Speed (rpm) and select bearing (d, D) to compute ndm.</div>');
                                  }
                                  parts.push('<div>ndm = n × dm = <strong>'+(isFinite(ndm)?ndm.toFixed(0):'—')+'</strong> mm·rpm</div>');
                                  parts.push('<div>ν (assumed) = '+nu+' cSt, ν₁ (ref) ≈ '+(isFinite(nu1)?nu1.toFixed(1):'—')+' cSt; κ = <strong>'+(isFinite(kappa)?kappa.toFixed(2):'—')+'</strong> ('+regime+')</div>');

                                  // Preferences UI
                                  parts.push('<div style="margin:8px 0; display:grid; grid-template-columns:repeat(auto-fit,minmax(180px,1fr)); gap:8px; font-size:13px;">'
                                      + '<label style="display:flex; align-items:center; gap:6px;"><input id="lub_req_cond" type="checkbox" '+(requireCond?'checked':'')+'> Conductivity required</label>'
                                      + '<label style="display:flex; align-items:center; gap:6px;"><input id="lub_plastic" type="checkbox" '+(plasticPresent?'checked':'')+'> Plastic parts present</label>'
                                      + '<label style="display:flex; align-items:center; gap:6px;"><input id="lub_cost" type="checkbox" '+(costSensitive?'checked':'')+'> Cost sensitive</label>'
                                      + '<label style="display:flex; align-items:center; gap:6px;"><input id="lub_noise" type="checkbox" '+(lowNoise?'checked':'')+'> Low noise priority</label>'
                                      + '<label style="display:flex; align-items:center; gap:6px;"><input id="lub_torque" type="checkbox" '+(lowTorque?'checked':'')+'> Low torque priority</label>'
                                      + '</div>');

                                  // Selection
                                  var sel = bc_selectGrease({ ndm: ndm, T: T, requireCond: requireCond, plasticPresent: plasticPresent, noise: lowNoise, torque: lowTorque, cost: costSensitive });
                                  if (!sel.scored || sel.scored.length === 0) {
                                      parts.push('<div style="color:#b91c1c;">No grease meets the constraints. Tip: adjust temperature, or uncheck conductivity/plastics constraint.</div>');
                                  } else {
                                      var top = sel.scored[0];
                                      var alts = sel.scored.slice(1,3);
                                      function gBadge(g){ return g.g.code + ' — ' + g.g.name; }
                                      // Persist recommendation for this bearing so other UI can read it
                                      try{
                                        if (!window.BC_OVERRIDES) window.BC_OVERRIDES = {};
                                        if (!window.BC_OVERRIDES[bearing]) window.BC_OVERRIDES[bearing] = {};
                                        window.BC_OVERRIDES[bearing].lubrication = window.BC_OVERRIDES[bearing].lubrication || {};
                                        window.BC_OVERRIDES[bearing].lubrication.choice = top.g.code;
                                        window.BC_OVERRIDES[bearing].lubrication.choice_label = gBadge(top);
                                        var lubeElChip = document.getElementById('res-setting-lube');
                                        if (lubeElChip) lubeElChip.textContent = top.g.code;
                                      }catch(e){}
                                      parts.push('<div style="margin-top:6px; padding:8px; border:1px solid #e5e7eb; border-radius:6px; background:#f9fafb;">'
                                          + '<div style="font-weight:600;">Recommended: <span style="color:#0d5cab;">'+gBadge(top)+'</span></div>'
                                          + '<div style="font-size:12px; color:#374151;">Temperature range '+top.g.temp_min_C+'…'+top.g.temp_max_C+' °C; Base oil: '+(top.g.base_oil||[]).join('/')+'; Thickener: '+top.g.thickener+'</div>'
                                          + '<div style="font-size:12px; color:#374151;">Score: '+top.score.toFixed(2)+'</div>'
                                          + '</div>');
                                      if (alts.length) {
                                          parts.push('<div style="margin-top:8px; font-weight:600;">Alternatives</div>');
                                          alts.forEach(function(a){
                                              parts.push('<div style="font-size:13px; color:#374151;">'+gBadge(a)+' <span style="color:#6b7280;">(score '+a.score.toFixed(2)+')</span></div>');
                                          });
                                      }
                                      // rationale
                                      parts.push('<div style="margin-top:8px; font-size:12px; color:#6b7280;">Notes: Performance criteria ranked 1–9. Temperature ranges reflect grease manufacturer guidance, not specific bearing limits. If plastics are present and compatibility is uncertain, consult NMB.</div>');
                                  }

                                  content = parts.join('');
                              })();
                              break;
                          default:
                              content = '<strong>'+ calcKey +'</strong>';
                      }
                      var oc = '<div style="margin-top:10px; padding:8px; background:#f9fafb; border:1px solid #eee; border-radius:6px;">'
                          + '<div style="font-weight:600; margin-bottom:4px;">Operating Conditions (placeholder)</div>'
                          + '<div style="display:grid; grid-template-columns: repeat(auto-fit,minmax(140px,1fr)); gap:6px; font-size:12px; color:#374151;">'
                          + '<div>Radial: '+(lc.radial||'—')+'</div><div>Axial: '+(lc.axial||'—')+'</div><div>Speed: '+(lc.speed||'—')+'</div><div>Temp: '+(lc.temp||'—')+'</div><div>Duty: '+(lc.duty||'—')+'</div>'
                          + '</div></div>';
                      panel.innerHTML = title + content + oc;
                      // Bind inline override inputs for certain calcs and re-render on change
                      try {
                          var bindIds = [];
                          if (calcKey === 'rating_life') { bindIds = ['rl_C','rl_p']; }
                          if (calcKey === 'static_safety') { bindIds = ['ss_Co','ss_X0','ss_Y0']; }
                          if (calcKey === 'load_level') { bindIds = []; }
                          if (calcKey === 'speed_level') { bindIds = ['sl_rs','sl_ls']; }
                          if (calcKey === 'lubrication') { bindIds = ['lub_req_cond','lub_plastic','lub_cost','lub_noise','lub_torque']; }
                          bindIds.forEach(function(id){
                              var el = document.getElementById(id);
                              if (el) {
                                  if (el._bcBound) return; el._bcBound = true;
                                  var evtName = (el.type === 'checkbox') ? 'change' : 'input';
                                  el.addEventListener(evtName, function(){
                                      // persist overrides
                                      var map = { 'rl_C':'C','rl_p':'p','ss_Co':'Co','ss_X0':'X0','ss_Y0':'Y0','ll_X':'X','ll_Y':'Y','ll_e':'e','sl_rs':'rs','sl_ls':'ls', 'lub_req_cond':'requireCond','lub_plastic':'plastic','lub_cost':'cost','lub_noise':'noise','lub_torque':'torque' };
                                      var key = map[id] || id;
                                      var v = (el.type === 'checkbox') ? (el.checked ? 1 : 0) : el.value;
                                      var num = (v === '' ? null : parseFloat(v));
                                      if (!window.BC_OVERRIDES) window.BC_OVERRIDES = {};
                                      if (!window.BC_OVERRIDES[bearing]) window.BC_OVERRIDES[bearing] = {};
                                      if (!window.BC_OVERRIDES[bearing][calcKey]) window.BC_OVERRIDES[bearing][calcKey] = {};
                                      window.BC_OVERRIDES[bearing][calcKey][key] = num;
                                      renderPanel(calcKey, bearing);
                                  });
                              }
                          });
                      } catch(e) {}
                  }

                  // Build bearing tabs
                  bearings.forEach(function(pn, idx){
                      var b = document.createElement('button');
                      b.type = 'button';
                      b.textContent = (window.BC_PARTS && window.BC_PARTS[pn] && window.BC_PARTS[pn].title) ? window.BC_PARTS[pn].title : pn;
                      b.setAttribute('data-bearing', pn);
                      styleAsTab(b, idx===0);
                      b.addEventListener('click', function(){
                          Array.prototype.forEach.call(tabsBearings.children, function(x){ styleAsTab(x, false); });
                          styleAsTab(b, true);
                          active.bearing = pn;
                          renderPanel(active.calc, active.bearing);
                      });
                      tabsBearings.appendChild(b);
                  });

                  // Build calc tabs
                  function makeCalcBtn(item, isActive){
                      var btn = document.createElement('button');
                      btn.type = 'button';
                      btn.textContent = item.title;
                      btn.setAttribute('data-calc', item.key);
                      styleAsTab(btn, isActive);
                      btn.addEventListener('click', function(){
                          Array.prototype.forEach.call(tabsCalcs.children, function(b){ styleAsTab(b, false); });
                          styleAsTab(btn, true);
                          active.calc = item.key;
                          renderPanel(active.calc, active.bearing);
                      });
                      return btn;
                  }
                  if (selected.length === 0) { selected = [{key:'load_level', title:'Load Level'}]; }
                  selected.forEach(function(item, idx){ tabsCalcs.appendChild(makeCalcBtn(item, idx===0)); });

                  // Initial render
                  renderPanel(active.calc, active.bearing);
                  updateResultsSummary();
              }
          });
      }
  }

  // Fits & Tolerances panel binding and render
  function fmtUmSigned(v){ return (typeof v === 'number' && isFinite(v)) ? ((v > 0 ? '+' : '') + v.toFixed(0) + ' µm') : '—'; }
  function fmtTolClass(v, upper){
    if (v==null || v==='') return '-';
    var s = String(v); var m = s.match(/^([A-Za-z]+)(.*)$/);
    if (!m) return s;
    return (upper ? m[1].toUpperCase() : m[1].toLowerCase()) + m[2];
  }
  function ftBuildCard(json, pn){
    var partData = (pn && window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
    var title = (partData && partData.title) ? partData.title : (pn || '—');
    var bore  = (partData && partData.d != null) ? (partData.d + ' mm') : '—';
    var od    = (partData && partData.D != null) ? (partData.D + ' mm') : '—';
    if (!json || !json.success) {
      var errText = (json && (json.error||json.message)) ? (json.error||json.message) : 'Unable to compute fit.';
      return '<div style="border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; box-shadow:0 1px 4px rgba(0,0,0,.06);">'
        + '<div style="background:#0d5cab; padding:10px 16px; display:flex; justify-content:space-between; align-items:center;">'
        + '<div style="font-weight:700; font-size:16px; color:#fff;">'+title+'</div>'
        + '<div style="display:flex; gap:16px; font-size:12px; color:rgba(255,255,255,.8);"><span>Bore: '+bore+'</span><span>OD: '+od+'</span></div>'
        + '</div>'
        + '<div style="padding:10px 16px; background:#fefce8; border-bottom:1px solid #fde68a; display:flex; align-items:center; gap:8px; font-size:12px; color:#92400e;"><span>⚠</span><span>'+errText+'</span></div>'
        + '</div>';
    }
    var rotation = (json.inputs && json.inputs.rotation) ? json.inputs.rotation : 'inner_rotates';
    var eff = json.effective_limits_um || {};
    var sLow  = eff.shaft && typeof eff.shaft.low  === 'number' ? eff.shaft.low  : null;
    var sHigh = eff.shaft && typeof eff.shaft.high === 'number' ? eff.shaft.high : null;
    var hLow  = eff.hole  && typeof eff.hole.low   === 'number' ? eff.hole.low   : null;
    var hHigh = eff.hole  && typeof eff.hole.high  === 'number' ? eff.hole.high  : null;
    var shaftC = fmtTolClass(json.inputs && json.inputs.shaft_class, false);
    var holeC  = fmtTolClass(json.inputs && json.inputs.hole_class,  true);
    var shaftRotating = rotation === 'inner_rotates';
    var shaftBg = shaftRotating ? '#f0f4ff' : '#f9fafb';
    var shaftBorder = shaftRotating ? '#bfdbfe' : '#e5e7eb';
    var holeBg = !shaftRotating ? '#f0f4ff' : '#f9fafb';
    var holeBorder = !shaftRotating ? '#bfdbfe' : '#e5e7eb';
    var syncIcon = '<span style="font-size:10px; color:#3b82f6;">&#x21BB;</span>';
    var shaftIcon = shaftRotating ? syncIcon : '';
    var holeIcon  = !shaftRotating ? syncIcon : '';
    var warnings = (json.warnings && json.warnings.length)
      ? '<div style="margin-top:8px; padding:6px 8px; background:#fff7ed; border:1px solid #fdba74; border-radius:6px; font-size:12px;">'+json.warnings.map(function(w){return '<div>• '+w+'</div>';}).join('')+'</div>'
      : '';
    return '<div style="border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; box-shadow:0 1px 4px rgba(0,0,0,.06);">'
      + '<div style="background:#0d5cab; padding:10px 16px; display:flex; justify-content:space-between; align-items:center;">'
      + '<div style="font-weight:700; font-size:16px; color:#fff;">'+title+'</div>'
      + '<div style="display:flex; gap:16px; font-size:12px; color:rgba(255,255,255,.8);"><span>Bore: '+bore+'</span><span>OD: '+od+'</span></div>'
      + '</div>'
      + '<div style="padding:16px;">'
      + '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">'
      + '<div style="padding:12px; border-radius:8px; background:'+shaftBg+'; border:1px solid '+shaftBorder+';">'
      + '<div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:4px;">'
      + '<div style="font-size:10px; font-weight:700; color:#9ca3af; text-transform:uppercase;">Shaft Fit ('+shaftC+')</div>'+shaftIcon
      + '</div>'
      + '<div style="font-size:16px; font-weight:700; color:#111827;">'+fmtUmSigned(sLow)+' / '+fmtUmSigned(sHigh)+'</div>'
      + '</div>'
      + '<div style="padding:12px; border-radius:8px; background:'+holeBg+'; border:1px solid '+holeBorder+';">'
      + '<div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:4px;">'
      + '<div style="font-size:10px; font-weight:700; color:#9ca3af; text-transform:uppercase;">Housing Fit ('+holeC+')</div>'+holeIcon
      + '</div>'
      + '<div style="font-size:16px; font-weight:700; color:#111827;">'+fmtUmSigned(hLow)+' / '+fmtUmSigned(hHigh)+'</div>'
      + '</div>'
      + '</div>'
      + warnings
      + '</div>'
      + '</div>';
  }
  function ftRenderAll(pns, map){
    var list = byId('ft-results-list'); if (!list) return;
    if (!pns || !pns.length) { list.innerHTML = '<div style="color:#6b7280; font-size:14px;">Select a bearing to evaluate fits.</div>'; return; }
    list.innerHTML = pns.map(function(pn){ return ftBuildCard(map[pn] || {success:false, error:'Computing…'}, pn); }).join('');
  }
  // Multi-bearing support
  function getSelectedPNs(){
    var pns = [];
    try {
      if (window.bcSelectedParts && typeof window.bcSelectedParts.forEach === 'function') {
        window.bcSelectedParts.forEach(function(v){ if (v!=null) pns.push(String(v)); });
      }
      if (!pns.length && window.BC_SELECTED && typeof window.BC_SELECTED.forEach === 'function') {
        window.BC_SELECTED.forEach(function(v){ if (v!=null) pns.push(String(v)); });
      }
      if (!pns.length) {
        var chips = Array.prototype.slice.call(document.querySelectorAll('#selection-chips .chip'));
        pns = chips.map(function(c){ return c.getAttribute('data-pn') || c.textContent.trim(); }).filter(Boolean);
      }
    } catch(e){}
    return pns.slice(0,5);
  }
  window.BC_FITS = window.BC_FITS || { cache:{}, token:0 };
  function ftKey(abec, rotation){ return String(abec)+'|'+String(rotation); }
  function ftComputeFor(pns){
    if (!pns || !pns.length) return;
    var abec = (document.getElementById('ft-abec') || {}).value || 'ABEC1';
    var rotEl = document.querySelector('input[name="fit-ring-rotation"]:checked');
    var rotation = rotEl ? rotEl.value : 'inner_rotates';
    var token = ++window.BC_FITS.token;
    pns.forEach(function(pn){ window.BC_FITS.cache[pn] = window.BC_FITS.cache[pn] || {}; window.BC_FITS.cache[pn][ftKey(abec,rotation)] = window.BC_FITS.cache[pn][ftKey(abec,rotation)] || null; });
    // Ensure part data is loaded before computing fits client-side
    ensurePartData(pns, function(){
      if (token !== window.BC_FITS.token) return;
      var key = ftKey(abec, rotation);
      var map = {};
      pns.forEach(function(pn){
        var data = (window.BC_PARTS && window.BC_PARTS[pn]) ? window.BC_PARTS[pn] : null;
        var json = bc_calculateFits(data, { abec: abec, rotation: rotation });
        window.BC_FITS.cache[pn][key] = json;
        map[pn] = json;
      });
      // Re-render all selected PNs so newly computed ones replace placeholders
      var allPns = getSelectedPNs();
      var fullMap = {};
      allPns.forEach(function(p){ if (window.BC_FITS.cache[p] && window.BC_FITS.cache[p][key]) fullMap[p] = window.BC_FITS.cache[p][key]; });
      ftRenderAll(allPns, fullMap);
    });
  }
  function ftComputeMulti(){
    var pns = getSelectedPNs();
    if (!pns.length){ ftRenderAll([], {}); return; }
    var abec = (document.getElementById('ft-abec') || {}).value || 'ABEC1';
    var rotEl = document.querySelector('input[name="fit-ring-rotation"]:checked');
    var rotation = rotEl ? rotEl.value : 'inner_rotates';
    var key = ftKey(abec, rotation);
    var need = pns.filter(function(pn){ return !(window.BC_FITS.cache[pn] && window.BC_FITS.cache[pn][key]); });
    // Show placeholders for any not-yet-computed PNs
    var map = {}; pns.forEach(function(pn){ if (window.BC_FITS.cache[pn] && window.BC_FITS.cache[pn][key]) map[pn] = window.BC_FITS.cache[pn][key]; });
    ftRenderAll(pns, map);
    if (need.length) ftComputeFor(need);
  }
  function bindFtOnce(){
    var abec = byId('ft-abec'); var radios = document.querySelectorAll('input[name="fit-ring-rotation"]');
    if (abec && !abec._bcBound){ abec._bcBound = true; abec.addEventListener('change', function(){ ftDebounce(ftComputeMulti); }); }
    Array.prototype.forEach.call(radios, function(r){ if (!r._bcBound){ r._bcBound=true; r.addEventListener('change', function(){ ftDebounce(ftComputeMulti); }); }});
    var chips = document.getElementById('selection-chips');
    if (chips && !chips.__bcFtObs){
      chips.__bcFtObs = true;
      var obs = new MutationObserver(function(){ ftDebounce(ftComputeMulti); });
      obs.observe(chips, {childList:true});
    }
  }
  var ftTimer=null; function ftDebounce(fn){ clearTimeout(ftTimer); ftTimer=setTimeout(fn,180); }
  function ftRotationToggle(val){
    var btnInner = byId('ft-btn-inner'); var btnOuter = byId('ft-btn-outer');
    var active = {background:'#fff', color:'#0d5cab', boxShadow:'0 1px 3px rgba(0,0,0,.12)'};
    var inactive = {background:'transparent', color:'#6b7280', boxShadow:'none'};
    var aStyle = val==='inner_rotates' ? active : inactive;
    var bStyle = val==='outer_rotates' ? active : inactive;
    if (btnInner) { btnInner.style.background=aStyle.background; btnInner.style.color=aStyle.color; btnInner.style.boxShadow=aStyle.boxShadow; }
    if (btnOuter) { btnOuter.style.background=bStyle.background; btnOuter.style.color=bStyle.color; btnOuter.style.boxShadow=bStyle.boxShadow; }
    ftDebounce(ftComputeMulti);
  }
  window.ftRotationToggle = ftRotationToggle;
  window.bcToggleGreaseCatalog = function(){
    var wrap = document.getElementById('grease-catalog-table-wrap');
    var btn  = document.getElementById('grease-catalog-toggle-btn');
    if (!wrap) return;
    var shown = wrap.style.display !== 'none';
    if (!shown) {
      // Lazy-build table rows on first open
      var tbody = document.getElementById('grease-catalog-tbody');
      // Full catalog, catalog_only entries included — same list the Inertia page shows
      if (tbody && !tbody.children.length && window.BC_GREASES) {
        var greases = window.BC_GREASES.slice();
        greases.forEach(function(g){
          var tr = document.createElement('tr');
          tr.onmouseover = function(){ this.style.background='#f9fafb'; };
          tr.onmouseout  = function(){ this.style.background=''; };
          function td(val, right){
            var c = document.createElement('td');
            c.style.cssText = 'border:1px solid #d1d5db; padding:4px 8px;' + (right ? 'text-align:right;' : '');
            c.textContent = (val === null || val === undefined) ? '-' : String(val);
            return c;
          }
          tr.appendChild(td(g.code));
          tr.appendChild(td(g.name));
          tr.appendChild(td(g.grease_type));
          tr.appendChild(td(g.thickener));
          tr.appendChild(td(Array.isArray(g.base_oil) ? g.base_oil.join(', ') : g.base_oil));
          tr.appendChild(td(g.visc40_cst != null ? g.visc40_cst : '-', true));
          tr.appendChild(td(g.penetration_25C_60W != null ? g.penetration_25C_60W : '-', true));
          tr.appendChild(td(g.temp_min_C + ' to ' + g.temp_max_C, true));
          tbody.appendChild(tr);
        });
      }
      wrap.style.display = 'block';
      if (btn) btn.textContent = 'Hide grease catalog';
    } else {
      wrap.style.display = 'none';
      if (btn) btn.textContent = 'Show grease catalog';
    }
  };
  function bcInitFitsPanel(){ bindFtOnce(); ftComputeMulti(); }
  window.bcInitFitsPanel = bcInitFitsPanel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
